/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AboutRouteImport } from './routes/_about'
import { Route as AppRouteImport } from './routes/_app'
import { Route as HomeRouteImport } from './routes/_home'
import { Route as LegalRouteImport } from './routes/_legal'
import { Route as OnboardingRouteImport } from './routes/_onboarding'
import { Route as PagesRouteImport } from './routes/_pages'
import { Route as HealthRouteImport } from './routes/health'
import { Route as RobotsDottxtRouteImport } from './routes/robots[.]txt'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as Sitemap_indexDotxmlRouteImport } from './routes/sitemap_index[.]xml'
import { Route as StoresRouteImport } from './routes/stores'
import { Route as AppLangRouteImport } from './routes/_app/$lang'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppListsRouteImport } from './routes/_app/lists'
import { Route as AppPartnersRouteImport } from './routes/_app/partners'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as PagesLangRouteImport } from './routes/_pages/$lang'
import { Route as ApiMcpRouteImport } from './routes/api/mcp'
import { Route as CdnSplatRouteImport } from './routes/cdn/$'
import { Route as SitemapArtistsDotxmlRouteImport } from './routes/sitemap/artists[.]xml'
import { Route as SitemapCompaniesDotxmlRouteImport } from './routes/sitemap/companies[.]xml'
import { Route as SitemapFeaturesDotxmlRouteImport } from './routes/sitemap/features[.]xml'
import { Route as SitemapListingsDotxmlRouteImport } from './routes/sitemap/listings[.]xml'
import { Route as SitemapListsDotxmlRouteImport } from './routes/sitemap/lists[.]xml'
import { Route as SitemapPostsDotxmlRouteImport } from './routes/sitemap/posts[.]xml'
import { Route as SitemapReleasesDotxmlRouteImport } from './routes/sitemap/releases[.]xml'
import { Route as SitemapStaticDotxmlRouteImport } from './routes/sitemap/static[.]xml'
import { Route as SitemapUsersDotxmlRouteImport } from './routes/sitemap/users[.]xml'
import { Route as SitemapWorksDotxmlRouteImport } from './routes/sitemap/works[.]xml'
import { Route as UnsubscribeNotificationsRouteImport } from './routes/unsubscribe/notifications'
import { Route as DotwellKnownApiCatalogIndexRouteImport } from './routes/[.]well-known/api-catalog/index'
import { Route as DotwellKnownOauthAuthorizationServerIndexRouteImport } from './routes/[.]well-known/oauth-authorization-server/index'
import { Route as DotwellKnownOauthProtectedResourceIndexRouteImport } from './routes/[.]well-known/oauth-protected-resource/index'
import { Route as DotwellKnownOpenidConfigurationIndexRouteImport } from './routes/[.]well-known/openid-configuration/index'
import { Route as AboutAboutProvidersRouteImport } from './routes/_about/about/providers'
import { Route as AppLangFamilyRouteImport } from './routes/_app/$lang/$family'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAlbumIdRouteImport } from './routes/_app/album/$id'
import { Route as AppAlertsIndexRouteImport } from './routes/_app/alerts/index'
import { Route as AppArtistIdRouteImport } from './routes/_app/artist/$id'
import { Route as AppCollectionSlugRouteImport } from './routes/_app/collection/$slug'
import { Route as AppCollectionsIndexRouteImport } from './routes/_app/collections/index'
import { Route as AppCollectionsSlugRouteImport } from './routes/_app/collections/$slug'
import { Route as AppCommunityIndexRouteImport } from './routes/_app/community/index'
import { Route as AppCommunityIdRouteImport } from './routes/_app/community/$id'
import { Route as AppCompanyIdRouteImport } from './routes/_app/company/$id'
import { Route as AppDiscoverIndexRouteImport } from './routes/_app/discover/index'
import { Route as AppForgotPasswordIndexRouteImport } from './routes/_app/forgot-password/index'
import { Route as AppGenreSlugRouteImport } from './routes/_app/genre/$slug'
import { Route as AppGenresIndexRouteImport } from './routes/_app/genres/index'
import { Route as AppGenresSlugRouteImport } from './routes/_app/genres/$slug'
import { Route as AppLabelIdRouteImport } from './routes/_app/label/$id'
import { Route as AppListingsIdRouteImport } from './routes/_app/listings/$id'
import { Route as AppListsIndexRouteImport } from './routes/_app/lists/index'
import { Route as AppListsCollectionRouteImport } from './routes/_app/lists/collection'
import { Route as AppLoginIndexRouteImport } from './routes/_app/login/index'
import { Route as AppMyOffersIndexRouteImport } from './routes/_app/my-offers/index'
import { Route as AppNotificationsIndexRouteImport } from './routes/_app/notifications/index'
import { Route as AppOffersIndexRouteImport } from './routes/_app/offers/index'
import { Route as AppPartnersIndexRouteImport } from './routes/_app/partners/index'
import { Route as AppPartnersOffersRouteImport } from './routes/_app/partners/offers'
import { Route as AppPostIdRouteImport } from './routes/_app/post/$id'
import { Route as AppReleaseIdRouteImport } from './routes/_app/release/$id'
import { Route as AppResetPasswordIndexRouteImport } from './routes/_app/reset-password/index'
import { Route as AppSearchIndexRouteImport } from './routes/_app/search/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppStoriesIndexRouteImport } from './routes/_app/stories/index'
import { Route as AppStoriesSlugRouteImport } from './routes/_app/stories/$slug'
import { Route as AppStorySlugRouteImport } from './routes/_app/story/$slug'
import { Route as AppStyleSlugRouteImport } from './routes/_app/style/$slug'
import { Route as AppStylesIndexRouteImport } from './routes/_app/styles/index'
import { Route as AppStylesSlugRouteImport } from './routes/_app/styles/$slug'
import { Route as AppTasteIndexRouteImport } from './routes/_app/taste/index'
import { Route as AppTelegramIndexRouteImport } from './routes/_app/telegram/index'
import { Route as AppUUsernameRouteImport } from './routes/_app/u/$username'
import { Route as AppWelcomeIndexRouteImport } from './routes/_app/welcome/index'
import { Route as AppWhatsappIndexRouteImport } from './routes/_app/whatsapp/index'
import { Route as AppWorkIdRouteImport } from './routes/_app/work/$id'
import { Route as LegalContactIndexRouteImport } from './routes/_legal/contact/index'
import { Route as LegalPrivacyIndexRouteImport } from './routes/_legal/privacy/index'
import { Route as LegalTermsIndexRouteImport } from './routes/_legal/terms/index'
import { Route as OnboardingOnboardingIndexRouteImport } from './routes/_onboarding/onboarding/index'
import { Route as PagesLangAboutRouteImport } from './routes/_pages/$lang/_about'
import { Route as PagesLangLegalRouteImport } from './routes/_pages/$lang/_legal'
import { Route as ApiAuthSplatRouteImport } from './routes/api/auth/$'
import { Route as ApiDiscogsCallbackRouteImport } from './routes/api/discogs/callback'
import { Route as ApiLastfmCallbackRouteImport } from './routes/api/lastfm/callback'
import { Route as ApiPushSubscriptionRouteImport } from './routes/api/push/subscription'
import { Route as ApiRpcSplatRouteImport } from './routes/api/rpc/$'
import { Route as ApiUnsubscribeNotificationsRouteImport } from './routes/api/unsubscribe/notifications'
import { Route as ApiWebhooksRastrRouteImport } from './routes/api/webhooks/rastr'
import { Route as ApiWebhooksResendRouteImport } from './routes/api/webhooks/resend'
import { Route as ApiWebhooksTelegramRouteImport } from './routes/api/webhooks/telegram'
import { Route as ApiWebhooksWahaRouteImport } from './routes/api/webhooks/waha'
import { Route as SitemapCatalogOffersDotxmlIndexRouteImport } from './routes/sitemap/catalog-offers[.]xml/index'
import { Route as SitemapCatalogDotxmlIndexRouteImport } from './routes/sitemap/catalog[.]xml/index'
import { Route as SitemapCatalogSplatRouteImport } from './routes/sitemap/catalog/$'
import { Route as DotwellKnownMcpServerCardDotjsonIndexRouteImport } from './routes/[.]well-known/mcp/server-card[.]json/index'
import { Route as DotwellKnownOauthAuthorizationServerApiAuthRouteImport } from './routes/[.]well-known/oauth-authorization-server/api/auth'
import { Route as DotwellKnownOauthProtectedResourceApiMcpRouteImport } from './routes/[.]well-known/oauth-protected-resource/api/mcp'
import { Route as AppLangFamilyIndexRouteImport } from './routes/_app/$lang/$family/index'
import { Route as AppLangFamilySlugRouteRouteImport } from './routes/_app/$lang/$family/$slug/route'
import { Route as AppLangArtistsIndexRouteImport } from './routes/_app/$lang/artists/index'
import { Route as AppLangEditorialIndexRouteImport } from './routes/_app/$lang/editorial/index'
import { Route as AppLangGarimposIndexRouteImport } from './routes/_app/$lang/garimpos/index'
import { Route as AppAdminAgentsIndexRouteImport } from './routes/_app/admin/agents/index'
import { Route as AppAdminChannelsIndexRouteImport } from './routes/_app/admin/channels/index'
import { Route as AppAdminCommandsIndexRouteImport } from './routes/_app/admin/commands/index'
import { Route as AppAdminFeaturePagesIndexRouteImport } from './routes/_app/admin/feature-pages/index'
import { Route as AppAdminOfferClicksIndexRouteImport } from './routes/_app/admin/offer-clicks/index'
import { Route as AppAdminOffersIndexRouteImport } from './routes/_app/admin/offers/index'
import { Route as AppAdminRequestsIndexRouteImport } from './routes/_app/admin/requests/index'
import { Route as AppAdminRequestsNewRouteImport } from './routes/_app/admin/requests/new'
import { Route as AppAdminReviewIndexRouteImport } from './routes/_app/admin/review/index'
import { Route as AppAdminSettingsIndexRouteImport } from './routes/_app/admin/settings/index'
import { Route as AppAdminTelegramIndexRouteImport } from './routes/_app/admin/telegram/index'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index'
import { Route as AppAdminWhatsappIndexRouteImport } from './routes/_app/admin/whatsapp/index'
import { Route as AppCommunityPeopleIndexRouteImport } from './routes/_app/community/people/index'
import { Route as AppListsIdIndexRouteImport } from './routes/_app/lists/$id/index'
import { Route as AppOauthConsentIndexRouteImport } from './routes/_app/oauth/consent/index'
import { Route as PagesLangStoresIndexRouteImport } from './routes/_pages/$lang/stores/index'
import { Route as ApiAdsCustomerMatchDotcsvIndexRouteImport } from './routes/api/ads/customer-match[.]csv/index'
import { Route as ApiPartnersOfferWorkbookIndexRouteImport } from './routes/api/partners/offer-workbook/index'
import { Route as AppLangFamilySlugIndexRouteImport } from './routes/_app/$lang/$family/$slug/index'
import { Route as AppLangFamilySlugDraftRouteImport } from './routes/_app/$lang/$family/$slug/draft'
import { Route as AppAdminOffersOfferIdIndexRouteImport } from './routes/_app/admin/offers/$offerId/index'
import { Route as AppAdminRequestsRequestIdIndexRouteImport } from './routes/_app/admin/requests/$requestId/index'
import { Route as AppAdminUsersUserIdIndexRouteImport } from './routes/_app/admin/users/$userId/index'
import { Route as PagesLangAboutAboutProvidersRouteImport } from './routes/_pages/$lang/_about/about/providers'
import { Route as PagesLangLegalContactIndexRouteImport } from './routes/_pages/$lang/_legal/contact/index'
import { Route as PagesLangLegalPrivacyIndexRouteImport } from './routes/_pages/$lang/_legal/privacy/index'
import { Route as PagesLangLegalTermsIndexRouteImport } from './routes/_pages/$lang/_legal/terms/index'
import { Route as PagesLangPagesCdPriceAlertsIndexRouteImport } from './routes/_pages/$lang/pages/cd-price-alerts/index'
import { Route as PagesLangPagesVinylPriceAlertsIndexRouteImport } from './routes/_pages/$lang/pages/vinyl-price-alerts/index'
import { Route as ApiInternalMediaAuthorizeUploadIndexRouteImport } from './routes/api/internal/media/authorize-upload/index'
import { Route as ApiInternalMediaCommitUploadIndexRouteImport } from './routes/api/internal/media/commit-upload/index'
import { Route as ApiInternalMediaSourceReferencesIndexRouteImport } from './routes/api/internal/media/source-references/index'
import { Route as AppListsIdItemsItemIdIndexRouteImport } from './routes/_app/lists/$id/items/$itemId/index'

const AboutRoute = AboutRouteImport.update({
  id: '/_about',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/_home',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/_legal',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesRoute = PagesRouteImport.update({
  id: '/_pages',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthRoute = HealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const RobotsDottxtRoute = RobotsDottxtRouteImport.update({
  id: '/robots.txt',
  path: '/robots.txt',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
  id: '/sitemap.xml',
  path: '/sitemap.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const Sitemap_indexDotxmlRoute = Sitemap_indexDotxmlRouteImport.update({
  id: '/sitemap_index.xml',
  path: '/sitemap_index.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const StoresRoute = StoresRouteImport.update({
  id: '/stores',
  path: '/stores',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLangRoute = AppLangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppListsRoute = AppListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => AppRoute,
} as any)
const AppPartnersRoute = AppPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => AppRoute,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HomeRoute,
} as any)
const PagesLangRoute = PagesLangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => PagesRoute,
} as any)
const ApiMcpRoute = ApiMcpRouteImport.update({
  id: '/api/mcp',
  path: '/api/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const CdnSplatRoute = CdnSplatRouteImport.update({
  id: '/cdn/$',
  path: '/cdn/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapArtistsDotxmlRoute = SitemapArtistsDotxmlRouteImport.update({
  id: '/sitemap/artists.xml',
  path: '/sitemap/artists.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapCompaniesDotxmlRoute = SitemapCompaniesDotxmlRouteImport.update({
  id: '/sitemap/companies.xml',
  path: '/sitemap/companies.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapFeaturesDotxmlRoute = SitemapFeaturesDotxmlRouteImport.update({
  id: '/sitemap/features.xml',
  path: '/sitemap/features.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapListingsDotxmlRoute = SitemapListingsDotxmlRouteImport.update({
  id: '/sitemap/listings.xml',
  path: '/sitemap/listings.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapListsDotxmlRoute = SitemapListsDotxmlRouteImport.update({
  id: '/sitemap/lists.xml',
  path: '/sitemap/lists.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapPostsDotxmlRoute = SitemapPostsDotxmlRouteImport.update({
  id: '/sitemap/posts.xml',
  path: '/sitemap/posts.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapReleasesDotxmlRoute = SitemapReleasesDotxmlRouteImport.update({
  id: '/sitemap/releases.xml',
  path: '/sitemap/releases.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapStaticDotxmlRoute = SitemapStaticDotxmlRouteImport.update({
  id: '/sitemap/static.xml',
  path: '/sitemap/static.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapUsersDotxmlRoute = SitemapUsersDotxmlRouteImport.update({
  id: '/sitemap/users.xml',
  path: '/sitemap/users.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapWorksDotxmlRoute = SitemapWorksDotxmlRouteImport.update({
  id: '/sitemap/works.xml',
  path: '/sitemap/works.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeNotificationsRoute =
  UnsubscribeNotificationsRouteImport.update({
    id: '/unsubscribe/notifications',
    path: '/unsubscribe/notifications',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotwellKnownApiCatalogIndexRoute =
  DotwellKnownApiCatalogIndexRouteImport.update({
    id: '/.well-known/api-catalog/',
    path: '/.well-known/api-catalog/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotwellKnownOauthAuthorizationServerIndexRoute =
  DotwellKnownOauthAuthorizationServerIndexRouteImport.update({
    id: '/.well-known/oauth-authorization-server/',
    path: '/.well-known/oauth-authorization-server/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotwellKnownOauthProtectedResourceIndexRoute =
  DotwellKnownOauthProtectedResourceIndexRouteImport.update({
    id: '/.well-known/oauth-protected-resource/',
    path: '/.well-known/oauth-protected-resource/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotwellKnownOpenidConfigurationIndexRoute =
  DotwellKnownOpenidConfigurationIndexRouteImport.update({
    id: '/.well-known/openid-configuration/',
    path: '/.well-known/openid-configuration/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AboutAboutProvidersRoute = AboutAboutProvidersRouteImport.update({
  id: '/about/providers',
  path: '/about/providers',
  getParentRoute: () => AboutRoute,
} as any)
const AppLangFamilyRoute = AppLangFamilyRouteImport.update({
  id: '/$family',
  path: '/$family',
  getParentRoute: () => AppLangRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAlbumIdRoute = AppAlbumIdRouteImport.update({
  id: '/album/$id',
  path: '/album/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsIndexRoute = AppAlertsIndexRouteImport.update({
  id: '/alerts/',
  path: '/alerts/',
  getParentRoute: () => AppRoute,
} as any)
const AppArtistIdRoute = AppArtistIdRouteImport.update({
  id: '/artist/$id',
  path: '/artist/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionSlugRoute = AppCollectionSlugRouteImport.update({
  id: '/collection/$slug',
  path: '/collection/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionsIndexRoute = AppCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionsSlugRoute = AppCollectionsSlugRouteImport.update({
  id: '/collections/$slug',
  path: '/collections/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunityIndexRoute = AppCommunityIndexRouteImport.update({
  id: '/community/',
  path: '/community/',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunityIdRoute = AppCommunityIdRouteImport.update({
  id: '/community/$id',
  path: '/community/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCompanyIdRoute = AppCompanyIdRouteImport.update({
  id: '/company/$id',
  path: '/company/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDiscoverIndexRoute = AppDiscoverIndexRouteImport.update({
  id: '/discover/',
  path: '/discover/',
  getParentRoute: () => AppRoute,
} as any)
const AppForgotPasswordIndexRoute = AppForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => AppRoute,
} as any)
const AppGenreSlugRoute = AppGenreSlugRouteImport.update({
  id: '/genre/$slug',
  path: '/genre/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppGenresIndexRoute = AppGenresIndexRouteImport.update({
  id: '/genres/',
  path: '/genres/',
  getParentRoute: () => AppRoute,
} as any)
const AppGenresSlugRoute = AppGenresSlugRouteImport.update({
  id: '/genres/$slug',
  path: '/genres/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppLabelIdRoute = AppLabelIdRouteImport.update({
  id: '/label/$id',
  path: '/label/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppListingsIdRoute = AppListingsIdRouteImport.update({
  id: '/listings/$id',
  path: '/listings/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppListsIndexRoute = AppListsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppListsRoute,
} as any)
const AppListsCollectionRoute = AppListsCollectionRouteImport.update({
  id: '/collection',
  path: '/collection',
  getParentRoute: () => AppListsRoute,
} as any)
const AppLoginIndexRoute = AppLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AppRoute,
} as any)
const AppMyOffersIndexRoute = AppMyOffersIndexRouteImport.update({
  id: '/my-offers/',
  path: '/my-offers/',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsIndexRoute = AppNotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => AppRoute,
} as any)
const AppOffersIndexRoute = AppOffersIndexRouteImport.update({
  id: '/offers/',
  path: '/offers/',
  getParentRoute: () => AppRoute,
} as any)
const AppPartnersIndexRoute = AppPartnersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPartnersRoute,
} as any)
const AppPartnersOffersRoute = AppPartnersOffersRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AppPartnersRoute,
} as any)
const AppPostIdRoute = AppPostIdRouteImport.update({
  id: '/post/$id',
  path: '/post/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppReleaseIdRoute = AppReleaseIdRouteImport.update({
  id: '/release/$id',
  path: '/release/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppResetPasswordIndexRoute = AppResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchIndexRoute = AppSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppStoriesIndexRoute = AppStoriesIndexRouteImport.update({
  id: '/stories/',
  path: '/stories/',
  getParentRoute: () => AppRoute,
} as any)
const AppStoriesSlugRoute = AppStoriesSlugRouteImport.update({
  id: '/stories/$slug',
  path: '/stories/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppStorySlugRoute = AppStorySlugRouteImport.update({
  id: '/story/$slug',
  path: '/story/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppStyleSlugRoute = AppStyleSlugRouteImport.update({
  id: '/style/$slug',
  path: '/style/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppStylesIndexRoute = AppStylesIndexRouteImport.update({
  id: '/styles/',
  path: '/styles/',
  getParentRoute: () => AppRoute,
} as any)
const AppStylesSlugRoute = AppStylesSlugRouteImport.update({
  id: '/styles/$slug',
  path: '/styles/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppTasteIndexRoute = AppTasteIndexRouteImport.update({
  id: '/taste/',
  path: '/taste/',
  getParentRoute: () => AppRoute,
} as any)
const AppTelegramIndexRoute = AppTelegramIndexRouteImport.update({
  id: '/telegram/',
  path: '/telegram/',
  getParentRoute: () => AppRoute,
} as any)
const AppUUsernameRoute = AppUUsernameRouteImport.update({
  id: '/u/$username',
  path: '/u/$username',
  getParentRoute: () => AppRoute,
} as any)
const AppWelcomeIndexRoute = AppWelcomeIndexRouteImport.update({
  id: '/welcome/',
  path: '/welcome/',
  getParentRoute: () => AppRoute,
} as any)
const AppWhatsappIndexRoute = AppWhatsappIndexRouteImport.update({
  id: '/whatsapp/',
  path: '/whatsapp/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkIdRoute = AppWorkIdRouteImport.update({
  id: '/work/$id',
  path: '/work/$id',
  getParentRoute: () => AppRoute,
} as any)
const LegalContactIndexRoute = LegalContactIndexRouteImport.update({
  id: '/contact/',
  path: '/contact/',
  getParentRoute: () => LegalRoute,
} as any)
const LegalPrivacyIndexRoute = LegalPrivacyIndexRouteImport.update({
  id: '/privacy/',
  path: '/privacy/',
  getParentRoute: () => LegalRoute,
} as any)
const LegalTermsIndexRoute = LegalTermsIndexRouteImport.update({
  id: '/terms/',
  path: '/terms/',
  getParentRoute: () => LegalRoute,
} as any)
const OnboardingOnboardingIndexRoute =
  OnboardingOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => OnboardingRoute,
  } as any)
const PagesLangAboutRoute = PagesLangAboutRouteImport.update({
  id: '/_about',
  getParentRoute: () => PagesLangRoute,
} as any)
const PagesLangLegalRoute = PagesLangLegalRouteImport.update({
  id: '/_legal',
  getParentRoute: () => PagesLangRoute,
} as any)
const ApiAuthSplatRoute = ApiAuthSplatRouteImport.update({
  id: '/api/auth/$',
  path: '/api/auth/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiDiscogsCallbackRoute = ApiDiscogsCallbackRouteImport.update({
  id: '/api/discogs/callback',
  path: '/api/discogs/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiLastfmCallbackRoute = ApiLastfmCallbackRouteImport.update({
  id: '/api/lastfm/callback',
  path: '/api/lastfm/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiPushSubscriptionRoute = ApiPushSubscriptionRouteImport.update({
  id: '/api/push/subscription',
  path: '/api/push/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiRpcSplatRoute = ApiRpcSplatRouteImport.update({
  id: '/api/rpc/$',
  path: '/api/rpc/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiUnsubscribeNotificationsRoute =
  ApiUnsubscribeNotificationsRouteImport.update({
    id: '/api/unsubscribe/notifications',
    path: '/api/unsubscribe/notifications',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApiWebhooksRastrRoute = ApiWebhooksRastrRouteImport.update({
  id: '/api/webhooks/rastr',
  path: '/api/webhooks/rastr',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiWebhooksResendRoute = ApiWebhooksResendRouteImport.update({
  id: '/api/webhooks/resend',
  path: '/api/webhooks/resend',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiWebhooksTelegramRoute = ApiWebhooksTelegramRouteImport.update({
  id: '/api/webhooks/telegram',
  path: '/api/webhooks/telegram',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiWebhooksWahaRoute = ApiWebhooksWahaRouteImport.update({
  id: '/api/webhooks/waha',
  path: '/api/webhooks/waha',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapCatalogOffersDotxmlIndexRoute =
  SitemapCatalogOffersDotxmlIndexRouteImport.update({
    id: '/sitemap/catalog-offers.xml/',
    path: '/sitemap/catalog-offers.xml/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SitemapCatalogDotxmlIndexRoute =
  SitemapCatalogDotxmlIndexRouteImport.update({
    id: '/sitemap/catalog.xml/',
    path: '/sitemap/catalog.xml/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SitemapCatalogSplatRoute = SitemapCatalogSplatRouteImport.update({
  id: '/sitemap/catalog/$',
  path: '/sitemap/catalog/$',
  getParentRoute: () => rootRouteImport,
} as any)
const DotwellKnownMcpServerCardDotjsonIndexRoute =
  DotwellKnownMcpServerCardDotjsonIndexRouteImport.update({
    id: '/.well-known/mcp/server-card.json/',
    path: '/.well-known/mcp/server-card.json/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotwellKnownOauthAuthorizationServerApiAuthRoute =
  DotwellKnownOauthAuthorizationServerApiAuthRouteImport.update({
    id: '/.well-known/oauth-authorization-server/api/auth',
    path: '/.well-known/oauth-authorization-server/api/auth',
    getParentRoute: () => rootRouteImport,
  } as any)
const DotwellKnownOauthProtectedResourceApiMcpRoute =
  DotwellKnownOauthProtectedResourceApiMcpRouteImport.update({
    id: '/.well-known/oauth-protected-resource/api/mcp',
    path: '/.well-known/oauth-protected-resource/api/mcp',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppLangFamilyIndexRoute = AppLangFamilyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLangFamilyRoute,
} as any)
const AppLangFamilySlugRouteRoute = AppLangFamilySlugRouteRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AppLangFamilyRoute,
} as any)
const AppLangArtistsIndexRoute = AppLangArtistsIndexRouteImport.update({
  id: '/artists/',
  path: '/artists/',
  getParentRoute: () => AppLangRoute,
} as any)
const AppLangEditorialIndexRoute = AppLangEditorialIndexRouteImport.update({
  id: '/editorial/',
  path: '/editorial/',
  getParentRoute: () => AppLangRoute,
} as any)
const AppLangGarimposIndexRoute = AppLangGarimposIndexRouteImport.update({
  id: '/garimpos/',
  path: '/garimpos/',
  getParentRoute: () => AppLangRoute,
} as any)
const AppAdminAgentsIndexRoute = AppAdminAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminChannelsIndexRoute = AppAdminChannelsIndexRouteImport.update({
  id: '/channels/',
  path: '/channels/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCommandsIndexRoute = AppAdminCommandsIndexRouteImport.update({
  id: '/commands/',
  path: '/commands/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFeaturePagesIndexRoute =
  AppAdminFeaturePagesIndexRouteImport.update({
    id: '/feature-pages/',
    path: '/feature-pages/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminOfferClicksIndexRoute =
  AppAdminOfferClicksIndexRouteImport.update({
    id: '/offer-clicks/',
    path: '/offer-clicks/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminOffersIndexRoute = AppAdminOffersIndexRouteImport.update({
  id: '/offers/',
  path: '/offers/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRequestsIndexRoute = AppAdminRequestsIndexRouteImport.update({
  id: '/requests/',
  path: '/requests/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRequestsNewRoute = AppAdminRequestsNewRouteImport.update({
  id: '/requests/new',
  path: '/requests/new',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminReviewIndexRoute = AppAdminReviewIndexRouteImport.update({
  id: '/review/',
  path: '/review/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSettingsIndexRoute = AppAdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTelegramIndexRoute = AppAdminTelegramIndexRouteImport.update({
  id: '/telegram/',
  path: '/telegram/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWhatsappIndexRoute = AppAdminWhatsappIndexRouteImport.update({
  id: '/whatsapp/',
  path: '/whatsapp/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppCommunityPeopleIndexRoute = AppCommunityPeopleIndexRouteImport.update({
  id: '/community/people/',
  path: '/community/people/',
  getParentRoute: () => AppRoute,
} as any)
const AppListsIdIndexRoute = AppListsIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AppListsRoute,
} as any)
const AppOauthConsentIndexRoute = AppOauthConsentIndexRouteImport.update({
  id: '/oauth/consent/',
  path: '/oauth/consent/',
  getParentRoute: () => AppRoute,
} as any)
const PagesLangStoresIndexRoute = PagesLangStoresIndexRouteImport.update({
  id: '/stores/',
  path: '/stores/',
  getParentRoute: () => PagesLangRoute,
} as any)
const ApiAdsCustomerMatchDotcsvIndexRoute =
  ApiAdsCustomerMatchDotcsvIndexRouteImport.update({
    id: '/api/ads/customer-match.csv/',
    path: '/api/ads/customer-match.csv/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApiPartnersOfferWorkbookIndexRoute =
  ApiPartnersOfferWorkbookIndexRouteImport.update({
    id: '/api/partners/offer-workbook/',
    path: '/api/partners/offer-workbook/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppLangFamilySlugIndexRoute = AppLangFamilySlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLangFamilySlugRouteRoute,
} as any)
const AppLangFamilySlugDraftRoute = AppLangFamilySlugDraftRouteImport.update({
  id: '/draft',
  path: '/draft',
  getParentRoute: () => AppLangFamilySlugRouteRoute,
} as any)
const AppAdminOffersOfferIdIndexRoute =
  AppAdminOffersOfferIdIndexRouteImport.update({
    id: '/offers/$offerId/',
    path: '/offers/$offerId/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminRequestsRequestIdIndexRoute =
  AppAdminRequestsRequestIdIndexRouteImport.update({
    id: '/requests/$requestId/',
    path: '/requests/$requestId/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminUsersUserIdIndexRoute =
  AppAdminUsersUserIdIndexRouteImport.update({
    id: '/users/$userId/',
    path: '/users/$userId/',
    getParentRoute: () => AppAdminRoute,
  } as any)
const PagesLangAboutAboutProvidersRoute =
  PagesLangAboutAboutProvidersRouteImport.update({
    id: '/about/providers',
    path: '/about/providers',
    getParentRoute: () => PagesLangAboutRoute,
  } as any)
const PagesLangLegalContactIndexRoute =
  PagesLangLegalContactIndexRouteImport.update({
    id: '/contact/',
    path: '/contact/',
    getParentRoute: () => PagesLangLegalRoute,
  } as any)
const PagesLangLegalPrivacyIndexRoute =
  PagesLangLegalPrivacyIndexRouteImport.update({
    id: '/privacy/',
    path: '/privacy/',
    getParentRoute: () => PagesLangLegalRoute,
  } as any)
const PagesLangLegalTermsIndexRoute =
  PagesLangLegalTermsIndexRouteImport.update({
    id: '/terms/',
    path: '/terms/',
    getParentRoute: () => PagesLangLegalRoute,
  } as any)
const PagesLangPagesCdPriceAlertsIndexRoute =
  PagesLangPagesCdPriceAlertsIndexRouteImport.update({
    id: '/pages/cd-price-alerts/',
    path: '/pages/cd-price-alerts/',
    getParentRoute: () => PagesLangRoute,
  } as any)
const PagesLangPagesVinylPriceAlertsIndexRoute =
  PagesLangPagesVinylPriceAlertsIndexRouteImport.update({
    id: '/pages/vinyl-price-alerts/',
    path: '/pages/vinyl-price-alerts/',
    getParentRoute: () => PagesLangRoute,
  } as any)
const ApiInternalMediaAuthorizeUploadIndexRoute =
  ApiInternalMediaAuthorizeUploadIndexRouteImport.update({
    id: '/api/internal/media/authorize-upload/',
    path: '/api/internal/media/authorize-upload/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApiInternalMediaCommitUploadIndexRoute =
  ApiInternalMediaCommitUploadIndexRouteImport.update({
    id: '/api/internal/media/commit-upload/',
    path: '/api/internal/media/commit-upload/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApiInternalMediaSourceReferencesIndexRoute =
  ApiInternalMediaSourceReferencesIndexRouteImport.update({
    id: '/api/internal/media/source-references/',
    path: '/api/internal/media/source-references/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppListsIdItemsItemIdIndexRoute =
  AppListsIdItemsItemIdIndexRouteImport.update({
    id: '/$id/items/$itemId/',
    path: '/$id/items/$itemId/',
    getParentRoute: () => AppListsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof HomeIndexRoute
  '/health': typeof HealthRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/sitemap_index.xml': typeof Sitemap_indexDotxmlRoute
  '/stores': typeof StoresRoute
  '/$lang': typeof PagesLangRouteWithChildren
  '/admin': typeof AppAdminRouteWithChildren
  '/lists': typeof AppListsRouteWithChildren
  '/partners': typeof AppPartnersRouteWithChildren
  '/api/mcp': typeof ApiMcpRoute
  '/cdn/$': typeof CdnSplatRoute
  '/sitemap/artists.xml': typeof SitemapArtistsDotxmlRoute
  '/sitemap/companies.xml': typeof SitemapCompaniesDotxmlRoute
  '/sitemap/features.xml': typeof SitemapFeaturesDotxmlRoute
  '/sitemap/listings.xml': typeof SitemapListingsDotxmlRoute
  '/sitemap/lists.xml': typeof SitemapListsDotxmlRoute
  '/sitemap/posts.xml': typeof SitemapPostsDotxmlRoute
  '/sitemap/releases.xml': typeof SitemapReleasesDotxmlRoute
  '/sitemap/static.xml': typeof SitemapStaticDotxmlRoute
  '/sitemap/users.xml': typeof SitemapUsersDotxmlRoute
  '/sitemap/works.xml': typeof SitemapWorksDotxmlRoute
  '/unsubscribe/notifications': typeof UnsubscribeNotificationsRoute
  '/about/providers': typeof AboutAboutProvidersRoute
  '/$lang/$family': typeof AppLangFamilyRouteWithChildren
  '/album/$id': typeof AppAlbumIdRoute
  '/artist/$id': typeof AppArtistIdRoute
  '/collection/$slug': typeof AppCollectionSlugRoute
  '/collections/$slug': typeof AppCollectionsSlugRoute
  '/community/$id': typeof AppCommunityIdRoute
  '/company/$id': typeof AppCompanyIdRoute
  '/genre/$slug': typeof AppGenreSlugRoute
  '/genres/$slug': typeof AppGenresSlugRoute
  '/label/$id': typeof AppLabelIdRoute
  '/listings/$id': typeof AppListingsIdRoute
  '/lists/collection': typeof AppListsCollectionRoute
  '/partners/offers': typeof AppPartnersOffersRoute
  '/post/$id': typeof AppPostIdRoute
  '/release/$id': typeof AppReleaseIdRoute
  '/stories/$slug': typeof AppStoriesSlugRoute
  '/story/$slug': typeof AppStorySlugRoute
  '/style/$slug': typeof AppStyleSlugRoute
  '/styles/$slug': typeof AppStylesSlugRoute
  '/u/$username': typeof AppUUsernameRoute
  '/work/$id': typeof AppWorkIdRoute
  '/api/auth/$': typeof ApiAuthSplatRoute
  '/api/discogs/callback': typeof ApiDiscogsCallbackRoute
  '/api/lastfm/callback': typeof ApiLastfmCallbackRoute
  '/api/push/subscription': typeof ApiPushSubscriptionRoute
  '/api/rpc/$': typeof ApiRpcSplatRoute
  '/api/unsubscribe/notifications': typeof ApiUnsubscribeNotificationsRoute
  '/api/webhooks/rastr': typeof ApiWebhooksRastrRoute
  '/api/webhooks/resend': typeof ApiWebhooksResendRoute
  '/api/webhooks/telegram': typeof ApiWebhooksTelegramRoute
  '/api/webhooks/waha': typeof ApiWebhooksWahaRoute
  '/sitemap/catalog/$': typeof SitemapCatalogSplatRoute
  '/.well-known/api-catalog/': typeof DotwellKnownApiCatalogIndexRoute
  '/.well-known/oauth-authorization-server/': typeof DotwellKnownOauthAuthorizationServerIndexRoute
  '/.well-known/oauth-protected-resource/': typeof DotwellKnownOauthProtectedResourceIndexRoute
  '/.well-known/openid-configuration/': typeof DotwellKnownOpenidConfigurationIndexRoute
  '/admin/': typeof AppAdminIndexRoute
  '/alerts/': typeof AppAlertsIndexRoute
  '/collections/': typeof AppCollectionsIndexRoute
  '/community/': typeof AppCommunityIndexRoute
  '/discover/': typeof AppDiscoverIndexRoute
  '/forgot-password/': typeof AppForgotPasswordIndexRoute
  '/genres/': typeof AppGenresIndexRoute
  '/lists/': typeof AppListsIndexRoute
  '/login/': typeof AppLoginIndexRoute
  '/my-offers/': typeof AppMyOffersIndexRoute
  '/notifications/': typeof AppNotificationsIndexRoute
  '/offers/': typeof AppOffersIndexRoute
  '/partners/': typeof AppPartnersIndexRoute
  '/reset-password/': typeof AppResetPasswordIndexRoute
  '/search/': typeof AppSearchIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/stories/': typeof AppStoriesIndexRoute
  '/styles/': typeof AppStylesIndexRoute
  '/taste/': typeof AppTasteIndexRoute
  '/telegram/': typeof AppTelegramIndexRoute
  '/welcome/': typeof AppWelcomeIndexRoute
  '/whatsapp/': typeof AppWhatsappIndexRoute
  '/contact/': typeof LegalContactIndexRoute
  '/privacy/': typeof LegalPrivacyIndexRoute
  '/terms/': typeof LegalTermsIndexRoute
  '/onboarding/': typeof OnboardingOnboardingIndexRoute
  '/sitemap/catalog-offers.xml/': typeof SitemapCatalogOffersDotxmlIndexRoute
  '/sitemap/catalog.xml/': typeof SitemapCatalogDotxmlIndexRoute
  '/$lang/$family/$slug': typeof AppLangFamilySlugRouteRouteWithChildren
  '/.well-known/oauth-authorization-server/api/auth': typeof DotwellKnownOauthAuthorizationServerApiAuthRoute
  '/.well-known/oauth-protected-resource/api/mcp': typeof DotwellKnownOauthProtectedResourceApiMcpRoute
  '/admin/requests/new': typeof AppAdminRequestsNewRoute
  '/.well-known/mcp/server-card.json/': typeof DotwellKnownMcpServerCardDotjsonIndexRoute
  '/$lang/$family/': typeof AppLangFamilyIndexRoute
  '/$lang/artists/': typeof AppLangArtistsIndexRoute
  '/$lang/editorial/': typeof AppLangEditorialIndexRoute
  '/$lang/garimpos/': typeof AppLangGarimposIndexRoute
  '/admin/agents/': typeof AppAdminAgentsIndexRoute
  '/admin/channels/': typeof AppAdminChannelsIndexRoute
  '/admin/commands/': typeof AppAdminCommandsIndexRoute
  '/admin/feature-pages/': typeof AppAdminFeaturePagesIndexRoute
  '/admin/offer-clicks/': typeof AppAdminOfferClicksIndexRoute
  '/admin/offers/': typeof AppAdminOffersIndexRoute
  '/admin/requests/': typeof AppAdminRequestsIndexRoute
  '/admin/review/': typeof AppAdminReviewIndexRoute
  '/admin/settings/': typeof AppAdminSettingsIndexRoute
  '/admin/telegram/': typeof AppAdminTelegramIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/admin/whatsapp/': typeof AppAdminWhatsappIndexRoute
  '/community/people/': typeof AppCommunityPeopleIndexRoute
  '/lists/$id/': typeof AppListsIdIndexRoute
  '/oauth/consent/': typeof AppOauthConsentIndexRoute
  '/$lang/stores/': typeof PagesLangStoresIndexRoute
  '/api/ads/customer-match.csv/': typeof ApiAdsCustomerMatchDotcsvIndexRoute
  '/api/partners/offer-workbook/': typeof ApiPartnersOfferWorkbookIndexRoute
  '/$lang/$family/$slug/draft': typeof AppLangFamilySlugDraftRoute
  '/$lang/about/providers': typeof PagesLangAboutAboutProvidersRoute
  '/$lang/$family/$slug/': typeof AppLangFamilySlugIndexRoute
  '/admin/offers/$offerId/': typeof AppAdminOffersOfferIdIndexRoute
  '/admin/requests/$requestId/': typeof AppAdminRequestsRequestIdIndexRoute
  '/admin/users/$userId/': typeof AppAdminUsersUserIdIndexRoute
  '/$lang/contact/': typeof PagesLangLegalContactIndexRoute
  '/$lang/privacy/': typeof PagesLangLegalPrivacyIndexRoute
  '/$lang/terms/': typeof PagesLangLegalTermsIndexRoute
  '/$lang/pages/cd-price-alerts/': typeof PagesLangPagesCdPriceAlertsIndexRoute
  '/$lang/pages/vinyl-price-alerts/': typeof PagesLangPagesVinylPriceAlertsIndexRoute
  '/api/internal/media/authorize-upload/': typeof ApiInternalMediaAuthorizeUploadIndexRoute
  '/api/internal/media/commit-upload/': typeof ApiInternalMediaCommitUploadIndexRoute
  '/api/internal/media/source-references/': typeof ApiInternalMediaSourceReferencesIndexRoute
  '/lists/$id/items/$itemId/': typeof AppListsIdItemsItemIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof HomeIndexRoute
  '/health': typeof HealthRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/sitemap_index.xml': typeof Sitemap_indexDotxmlRoute
  '/stores': typeof StoresRoute
  '/$lang': typeof PagesLangRouteWithChildren
  '/api/mcp': typeof ApiMcpRoute
  '/cdn/$': typeof CdnSplatRoute
  '/sitemap/artists.xml': typeof SitemapArtistsDotxmlRoute
  '/sitemap/companies.xml': typeof SitemapCompaniesDotxmlRoute
  '/sitemap/features.xml': typeof SitemapFeaturesDotxmlRoute
  '/sitemap/listings.xml': typeof SitemapListingsDotxmlRoute
  '/sitemap/lists.xml': typeof SitemapListsDotxmlRoute
  '/sitemap/posts.xml': typeof SitemapPostsDotxmlRoute
  '/sitemap/releases.xml': typeof SitemapReleasesDotxmlRoute
  '/sitemap/static.xml': typeof SitemapStaticDotxmlRoute
  '/sitemap/users.xml': typeof SitemapUsersDotxmlRoute
  '/sitemap/works.xml': typeof SitemapWorksDotxmlRoute
  '/unsubscribe/notifications': typeof UnsubscribeNotificationsRoute
  '/about/providers': typeof AboutAboutProvidersRoute
  '/album/$id': typeof AppAlbumIdRoute
  '/artist/$id': typeof AppArtistIdRoute
  '/collection/$slug': typeof AppCollectionSlugRoute
  '/collections/$slug': typeof AppCollectionsSlugRoute
  '/community/$id': typeof AppCommunityIdRoute
  '/company/$id': typeof AppCompanyIdRoute
  '/genre/$slug': typeof AppGenreSlugRoute
  '/genres/$slug': typeof AppGenresSlugRoute
  '/label/$id': typeof AppLabelIdRoute
  '/listings/$id': typeof AppListingsIdRoute
  '/lists/collection': typeof AppListsCollectionRoute
  '/partners/offers': typeof AppPartnersOffersRoute
  '/post/$id': typeof AppPostIdRoute
  '/release/$id': typeof AppReleaseIdRoute
  '/stories/$slug': typeof AppStoriesSlugRoute
  '/story/$slug': typeof AppStorySlugRoute
  '/style/$slug': typeof AppStyleSlugRoute
  '/styles/$slug': typeof AppStylesSlugRoute
  '/u/$username': typeof AppUUsernameRoute
  '/work/$id': typeof AppWorkIdRoute
  '/api/auth/$': typeof ApiAuthSplatRoute
  '/api/discogs/callback': typeof ApiDiscogsCallbackRoute
  '/api/lastfm/callback': typeof ApiLastfmCallbackRoute
  '/api/push/subscription': typeof ApiPushSubscriptionRoute
  '/api/rpc/$': typeof ApiRpcSplatRoute
  '/api/unsubscribe/notifications': typeof ApiUnsubscribeNotificationsRoute
  '/api/webhooks/rastr': typeof ApiWebhooksRastrRoute
  '/api/webhooks/resend': typeof ApiWebhooksResendRoute
  '/api/webhooks/telegram': typeof ApiWebhooksTelegramRoute
  '/api/webhooks/waha': typeof ApiWebhooksWahaRoute
  '/sitemap/catalog/$': typeof SitemapCatalogSplatRoute
  '/.well-known/api-catalog': typeof DotwellKnownApiCatalogIndexRoute
  '/.well-known/oauth-authorization-server': typeof DotwellKnownOauthAuthorizationServerIndexRoute
  '/.well-known/oauth-protected-resource': typeof DotwellKnownOauthProtectedResourceIndexRoute
  '/.well-known/openid-configuration': typeof DotwellKnownOpenidConfigurationIndexRoute
  '/admin': typeof AppAdminIndexRoute
  '/alerts': typeof AppAlertsIndexRoute
  '/collections': typeof AppCollectionsIndexRoute
  '/community': typeof AppCommunityIndexRoute
  '/discover': typeof AppDiscoverIndexRoute
  '/forgot-password': typeof AppForgotPasswordIndexRoute
  '/genres': typeof AppGenresIndexRoute
  '/lists': typeof AppListsIndexRoute
  '/login': typeof AppLoginIndexRoute
  '/my-offers': typeof AppMyOffersIndexRoute
  '/notifications': typeof AppNotificationsIndexRoute
  '/offers': typeof AppOffersIndexRoute
  '/partners': typeof AppPartnersIndexRoute
  '/reset-password': typeof AppResetPasswordIndexRoute
  '/search': typeof AppSearchIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/stories': typeof AppStoriesIndexRoute
  '/styles': typeof AppStylesIndexRoute
  '/taste': typeof AppTasteIndexRoute
  '/telegram': typeof AppTelegramIndexRoute
  '/welcome': typeof AppWelcomeIndexRoute
  '/whatsapp': typeof AppWhatsappIndexRoute
  '/contact': typeof LegalContactIndexRoute
  '/privacy': typeof LegalPrivacyIndexRoute
  '/terms': typeof LegalTermsIndexRoute
  '/onboarding': typeof OnboardingOnboardingIndexRoute
  '/sitemap/catalog-offers.xml': typeof SitemapCatalogOffersDotxmlIndexRoute
  '/sitemap/catalog.xml': typeof SitemapCatalogDotxmlIndexRoute
  '/.well-known/oauth-authorization-server/api/auth': typeof DotwellKnownOauthAuthorizationServerApiAuthRoute
  '/.well-known/oauth-protected-resource/api/mcp': typeof DotwellKnownOauthProtectedResourceApiMcpRoute
  '/admin/requests/new': typeof AppAdminRequestsNewRoute
  '/.well-known/mcp/server-card.json': typeof DotwellKnownMcpServerCardDotjsonIndexRoute
  '/$lang/$family': typeof AppLangFamilyIndexRoute
  '/$lang/artists': typeof AppLangArtistsIndexRoute
  '/$lang/editorial': typeof AppLangEditorialIndexRoute
  '/$lang/garimpos': typeof AppLangGarimposIndexRoute
  '/admin/agents': typeof AppAdminAgentsIndexRoute
  '/admin/channels': typeof AppAdminChannelsIndexRoute
  '/admin/commands': typeof AppAdminCommandsIndexRoute
  '/admin/feature-pages': typeof AppAdminFeaturePagesIndexRoute
  '/admin/offer-clicks': typeof AppAdminOfferClicksIndexRoute
  '/admin/offers': typeof AppAdminOffersIndexRoute
  '/admin/requests': typeof AppAdminRequestsIndexRoute
  '/admin/review': typeof AppAdminReviewIndexRoute
  '/admin/settings': typeof AppAdminSettingsIndexRoute
  '/admin/telegram': typeof AppAdminTelegramIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/admin/whatsapp': typeof AppAdminWhatsappIndexRoute
  '/community/people': typeof AppCommunityPeopleIndexRoute
  '/lists/$id': typeof AppListsIdIndexRoute
  '/oauth/consent': typeof AppOauthConsentIndexRoute
  '/$lang/stores': typeof PagesLangStoresIndexRoute
  '/api/ads/customer-match.csv': typeof ApiAdsCustomerMatchDotcsvIndexRoute
  '/api/partners/offer-workbook': typeof ApiPartnersOfferWorkbookIndexRoute
  '/$lang/$family/$slug/draft': typeof AppLangFamilySlugDraftRoute
  '/$lang/about/providers': typeof PagesLangAboutAboutProvidersRoute
  '/$lang/$family/$slug': typeof AppLangFamilySlugIndexRoute
  '/admin/offers/$offerId': typeof AppAdminOffersOfferIdIndexRoute
  '/admin/requests/$requestId': typeof AppAdminRequestsRequestIdIndexRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdIndexRoute
  '/$lang/contact': typeof PagesLangLegalContactIndexRoute
  '/$lang/privacy': typeof PagesLangLegalPrivacyIndexRoute
  '/$lang/terms': typeof PagesLangLegalTermsIndexRoute
  '/$lang/pages/cd-price-alerts': typeof PagesLangPagesCdPriceAlertsIndexRoute
  '/$lang/pages/vinyl-price-alerts': typeof PagesLangPagesVinylPriceAlertsIndexRoute
  '/api/internal/media/authorize-upload': typeof ApiInternalMediaAuthorizeUploadIndexRoute
  '/api/internal/media/commit-upload': typeof ApiInternalMediaCommitUploadIndexRoute
  '/api/internal/media/source-references': typeof ApiInternalMediaSourceReferencesIndexRoute
  '/lists/$id/items/$itemId': typeof AppListsIdItemsItemIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_about': typeof AboutRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/_home': typeof HomeRouteWithChildren
  '/_legal': typeof LegalRouteWithChildren
  '/_onboarding': typeof OnboardingRouteWithChildren
  '/_pages': typeof PagesRouteWithChildren
  '/health': typeof HealthRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/sitemap_index.xml': typeof Sitemap_indexDotxmlRoute
  '/stores': typeof StoresRoute
  '/_app/$lang': typeof AppLangRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/lists': typeof AppListsRouteWithChildren
  '/_app/partners': typeof AppPartnersRouteWithChildren
  '/_pages/$lang': typeof PagesLangRouteWithChildren
  '/api/mcp': typeof ApiMcpRoute
  '/cdn/$': typeof CdnSplatRoute
  '/sitemap/artists.xml': typeof SitemapArtistsDotxmlRoute
  '/sitemap/companies.xml': typeof SitemapCompaniesDotxmlRoute
  '/sitemap/features.xml': typeof SitemapFeaturesDotxmlRoute
  '/sitemap/listings.xml': typeof SitemapListingsDotxmlRoute
  '/sitemap/lists.xml': typeof SitemapListsDotxmlRoute
  '/sitemap/posts.xml': typeof SitemapPostsDotxmlRoute
  '/sitemap/releases.xml': typeof SitemapReleasesDotxmlRoute
  '/sitemap/static.xml': typeof SitemapStaticDotxmlRoute
  '/sitemap/users.xml': typeof SitemapUsersDotxmlRoute
  '/sitemap/works.xml': typeof SitemapWorksDotxmlRoute
  '/unsubscribe/notifications': typeof UnsubscribeNotificationsRoute
  '/_home/': typeof HomeIndexRoute
  '/_about/about/providers': typeof AboutAboutProvidersRoute
  '/_app/$lang/$family': typeof AppLangFamilyRouteWithChildren
  '/_app/album/$id': typeof AppAlbumIdRoute
  '/_app/artist/$id': typeof AppArtistIdRoute
  '/_app/collection/$slug': typeof AppCollectionSlugRoute
  '/_app/collections/$slug': typeof AppCollectionsSlugRoute
  '/_app/community/$id': typeof AppCommunityIdRoute
  '/_app/company/$id': typeof AppCompanyIdRoute
  '/_app/genre/$slug': typeof AppGenreSlugRoute
  '/_app/genres/$slug': typeof AppGenresSlugRoute
  '/_app/label/$id': typeof AppLabelIdRoute
  '/_app/listings/$id': typeof AppListingsIdRoute
  '/_app/lists/collection': typeof AppListsCollectionRoute
  '/_app/partners/offers': typeof AppPartnersOffersRoute
  '/_app/post/$id': typeof AppPostIdRoute
  '/_app/release/$id': typeof AppReleaseIdRoute
  '/_app/stories/$slug': typeof AppStoriesSlugRoute
  '/_app/story/$slug': typeof AppStorySlugRoute
  '/_app/style/$slug': typeof AppStyleSlugRoute
  '/_app/styles/$slug': typeof AppStylesSlugRoute
  '/_app/u/$username': typeof AppUUsernameRoute
  '/_app/work/$id': typeof AppWorkIdRoute
  '/_pages/$lang/_about': typeof PagesLangAboutRouteWithChildren
  '/_pages/$lang/_legal': typeof PagesLangLegalRouteWithChildren
  '/api/auth/$': typeof ApiAuthSplatRoute
  '/api/discogs/callback': typeof ApiDiscogsCallbackRoute
  '/api/lastfm/callback': typeof ApiLastfmCallbackRoute
  '/api/push/subscription': typeof ApiPushSubscriptionRoute
  '/api/rpc/$': typeof ApiRpcSplatRoute
  '/api/unsubscribe/notifications': typeof ApiUnsubscribeNotificationsRoute
  '/api/webhooks/rastr': typeof ApiWebhooksRastrRoute
  '/api/webhooks/resend': typeof ApiWebhooksResendRoute
  '/api/webhooks/telegram': typeof ApiWebhooksTelegramRoute
  '/api/webhooks/waha': typeof ApiWebhooksWahaRoute
  '/sitemap/catalog/$': typeof SitemapCatalogSplatRoute
  '/.well-known/api-catalog/': typeof DotwellKnownApiCatalogIndexRoute
  '/.well-known/oauth-authorization-server/': typeof DotwellKnownOauthAuthorizationServerIndexRoute
  '/.well-known/oauth-protected-resource/': typeof DotwellKnownOauthProtectedResourceIndexRoute
  '/.well-known/openid-configuration/': typeof DotwellKnownOpenidConfigurationIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/alerts/': typeof AppAlertsIndexRoute
  '/_app/collections/': typeof AppCollectionsIndexRoute
  '/_app/community/': typeof AppCommunityIndexRoute
  '/_app/discover/': typeof AppDiscoverIndexRoute
  '/_app/forgot-password/': typeof AppForgotPasswordIndexRoute
  '/_app/genres/': typeof AppGenresIndexRoute
  '/_app/lists/': typeof AppListsIndexRoute
  '/_app/login/': typeof AppLoginIndexRoute
  '/_app/my-offers/': typeof AppMyOffersIndexRoute
  '/_app/notifications/': typeof AppNotificationsIndexRoute
  '/_app/offers/': typeof AppOffersIndexRoute
  '/_app/partners/': typeof AppPartnersIndexRoute
  '/_app/reset-password/': typeof AppResetPasswordIndexRoute
  '/_app/search/': typeof AppSearchIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/stories/': typeof AppStoriesIndexRoute
  '/_app/styles/': typeof AppStylesIndexRoute
  '/_app/taste/': typeof AppTasteIndexRoute
  '/_app/telegram/': typeof AppTelegramIndexRoute
  '/_app/welcome/': typeof AppWelcomeIndexRoute
  '/_app/whatsapp/': typeof AppWhatsappIndexRoute
  '/_legal/contact/': typeof LegalContactIndexRoute
  '/_legal/privacy/': typeof LegalPrivacyIndexRoute
  '/_legal/terms/': typeof LegalTermsIndexRoute
  '/_onboarding/onboarding/': typeof OnboardingOnboardingIndexRoute
  '/sitemap/catalog-offers.xml/': typeof SitemapCatalogOffersDotxmlIndexRoute
  '/sitemap/catalog.xml/': typeof SitemapCatalogDotxmlIndexRoute
  '/_app/$lang/$family/$slug': typeof AppLangFamilySlugRouteRouteWithChildren
  '/.well-known/oauth-authorization-server/api/auth': typeof DotwellKnownOauthAuthorizationServerApiAuthRoute
  '/.well-known/oauth-protected-resource/api/mcp': typeof DotwellKnownOauthProtectedResourceApiMcpRoute
  '/_app/admin/requests/new': typeof AppAdminRequestsNewRoute
  '/.well-known/mcp/server-card.json/': typeof DotwellKnownMcpServerCardDotjsonIndexRoute
  '/_app/$lang/$family/': typeof AppLangFamilyIndexRoute
  '/_app/$lang/artists/': typeof AppLangArtistsIndexRoute
  '/_app/$lang/editorial/': typeof AppLangEditorialIndexRoute
  '/_app/$lang/garimpos/': typeof AppLangGarimposIndexRoute
  '/_app/admin/agents/': typeof AppAdminAgentsIndexRoute
  '/_app/admin/channels/': typeof AppAdminChannelsIndexRoute
  '/_app/admin/commands/': typeof AppAdminCommandsIndexRoute
  '/_app/admin/feature-pages/': typeof AppAdminFeaturePagesIndexRoute
  '/_app/admin/offer-clicks/': typeof AppAdminOfferClicksIndexRoute
  '/_app/admin/offers/': typeof AppAdminOffersIndexRoute
  '/_app/admin/requests/': typeof AppAdminRequestsIndexRoute
  '/_app/admin/review/': typeof AppAdminReviewIndexRoute
  '/_app/admin/settings/': typeof AppAdminSettingsIndexRoute
  '/_app/admin/telegram/': typeof AppAdminTelegramIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/admin/whatsapp/': typeof AppAdminWhatsappIndexRoute
  '/_app/community/people/': typeof AppCommunityPeopleIndexRoute
  '/_app/lists/$id/': typeof AppListsIdIndexRoute
  '/_app/oauth/consent/': typeof AppOauthConsentIndexRoute
  '/_pages/$lang/stores/': typeof PagesLangStoresIndexRoute
  '/api/ads/customer-match.csv/': typeof ApiAdsCustomerMatchDotcsvIndexRoute
  '/api/partners/offer-workbook/': typeof ApiPartnersOfferWorkbookIndexRoute
  '/_app/$lang/$family/$slug/draft': typeof AppLangFamilySlugDraftRoute
  '/_pages/$lang/_about/about/providers': typeof PagesLangAboutAboutProvidersRoute
  '/_app/$lang/$family/$slug/': typeof AppLangFamilySlugIndexRoute
  '/_app/admin/offers/$offerId/': typeof AppAdminOffersOfferIdIndexRoute
  '/_app/admin/requests/$requestId/': typeof AppAdminRequestsRequestIdIndexRoute
  '/_app/admin/users/$userId/': typeof AppAdminUsersUserIdIndexRoute
  '/_pages/$lang/_legal/contact/': typeof PagesLangLegalContactIndexRoute
  '/_pages/$lang/_legal/privacy/': typeof PagesLangLegalPrivacyIndexRoute
  '/_pages/$lang/_legal/terms/': typeof PagesLangLegalTermsIndexRoute
  '/_pages/$lang/pages/cd-price-alerts/': typeof PagesLangPagesCdPriceAlertsIndexRoute
  '/_pages/$lang/pages/vinyl-price-alerts/': typeof PagesLangPagesVinylPriceAlertsIndexRoute
  '/api/internal/media/authorize-upload/': typeof ApiInternalMediaAuthorizeUploadIndexRoute
  '/api/internal/media/commit-upload/': typeof ApiInternalMediaCommitUploadIndexRoute
  '/api/internal/media/source-references/': typeof ApiInternalMediaSourceReferencesIndexRoute
  '/_app/lists/$id/items/$itemId/': typeof AppListsIdItemsItemIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/health'
    | '/robots.txt'
    | '/sitemap.xml'
    | '/sitemap_index.xml'
    | '/stores'
    | '/$lang'
    | '/admin'
    | '/lists'
    | '/partners'
    | '/api/mcp'
    | '/cdn/$'
    | '/sitemap/artists.xml'
    | '/sitemap/companies.xml'
    | '/sitemap/features.xml'
    | '/sitemap/listings.xml'
    | '/sitemap/lists.xml'
    | '/sitemap/posts.xml'
    | '/sitemap/releases.xml'
    | '/sitemap/static.xml'
    | '/sitemap/users.xml'
    | '/sitemap/works.xml'
    | '/unsubscribe/notifications'
    | '/about/providers'
    | '/$lang/$family'
    | '/album/$id'
    | '/artist/$id'
    | '/collection/$slug'
    | '/collections/$slug'
    | '/community/$id'
    | '/company/$id'
    | '/genre/$slug'
    | '/genres/$slug'
    | '/label/$id'
    | '/listings/$id'
    | '/lists/collection'
    | '/partners/offers'
    | '/post/$id'
    | '/release/$id'
    | '/stories/$slug'
    | '/story/$slug'
    | '/style/$slug'
    | '/styles/$slug'
    | '/u/$username'
    | '/work/$id'
    | '/api/auth/$'
    | '/api/discogs/callback'
    | '/api/lastfm/callback'
    | '/api/push/subscription'
    | '/api/rpc/$'
    | '/api/unsubscribe/notifications'
    | '/api/webhooks/rastr'
    | '/api/webhooks/resend'
    | '/api/webhooks/telegram'
    | '/api/webhooks/waha'
    | '/sitemap/catalog/$'
    | '/.well-known/api-catalog/'
    | '/.well-known/oauth-authorization-server/'
    | '/.well-known/oauth-protected-resource/'
    | '/.well-known/openid-configuration/'
    | '/admin/'
    | '/alerts/'
    | '/collections/'
    | '/community/'
    | '/discover/'
    | '/forgot-password/'
    | '/genres/'
    | '/lists/'
    | '/login/'
    | '/my-offers/'
    | '/notifications/'
    | '/offers/'
    | '/partners/'
    | '/reset-password/'
    | '/search/'
    | '/settings/'
    | '/stories/'
    | '/styles/'
    | '/taste/'
    | '/telegram/'
    | '/welcome/'
    | '/whatsapp/'
    | '/contact/'
    | '/privacy/'
    | '/terms/'
    | '/onboarding/'
    | '/sitemap/catalog-offers.xml/'
    | '/sitemap/catalog.xml/'
    | '/$lang/$family/$slug'
    | '/.well-known/oauth-authorization-server/api/auth'
    | '/.well-known/oauth-protected-resource/api/mcp'
    | '/admin/requests/new'
    | '/.well-known/mcp/server-card.json/'
    | '/$lang/$family/'
    | '/$lang/artists/'
    | '/$lang/editorial/'
    | '/$lang/garimpos/'
    | '/admin/agents/'
    | '/admin/channels/'
    | '/admin/commands/'
    | '/admin/feature-pages/'
    | '/admin/offer-clicks/'
    | '/admin/offers/'
    | '/admin/requests/'
    | '/admin/review/'
    | '/admin/settings/'
    | '/admin/telegram/'
    | '/admin/users/'
    | '/admin/whatsapp/'
    | '/community/people/'
    | '/lists/$id/'
    | '/oauth/consent/'
    | '/$lang/stores/'
    | '/api/ads/customer-match.csv/'
    | '/api/partners/offer-workbook/'
    | '/$lang/$family/$slug/draft'
    | '/$lang/about/providers'
    | '/$lang/$family/$slug/'
    | '/admin/offers/$offerId/'
    | '/admin/requests/$requestId/'
    | '/admin/users/$userId/'
    | '/$lang/contact/'
    | '/$lang/privacy/'
    | '/$lang/terms/'
    | '/$lang/pages/cd-price-alerts/'
    | '/$lang/pages/vinyl-price-alerts/'
    | '/api/internal/media/authorize-upload/'
    | '/api/internal/media/commit-upload/'
    | '/api/internal/media/source-references/'
    | '/lists/$id/items/$itemId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/health'
    | '/robots.txt'
    | '/sitemap.xml'
    | '/sitemap_index.xml'
    | '/stores'
    | '/$lang'
    | '/api/mcp'
    | '/cdn/$'
    | '/sitemap/artists.xml'
    | '/sitemap/companies.xml'
    | '/sitemap/features.xml'
    | '/sitemap/listings.xml'
    | '/sitemap/lists.xml'
    | '/sitemap/posts.xml'
    | '/sitemap/releases.xml'
    | '/sitemap/static.xml'
    | '/sitemap/users.xml'
    | '/sitemap/works.xml'
    | '/unsubscribe/notifications'
    | '/about/providers'
    | '/album/$id'
    | '/artist/$id'
    | '/collection/$slug'
    | '/collections/$slug'
    | '/community/$id'
    | '/company/$id'
    | '/genre/$slug'
    | '/genres/$slug'
    | '/label/$id'
    | '/listings/$id'
    | '/lists/collection'
    | '/partners/offers'
    | '/post/$id'
    | '/release/$id'
    | '/stories/$slug'
    | '/story/$slug'
    | '/style/$slug'
    | '/styles/$slug'
    | '/u/$username'
    | '/work/$id'
    | '/api/auth/$'
    | '/api/discogs/callback'
    | '/api/lastfm/callback'
    | '/api/push/subscription'
    | '/api/rpc/$'
    | '/api/unsubscribe/notifications'
    | '/api/webhooks/rastr'
    | '/api/webhooks/resend'
    | '/api/webhooks/telegram'
    | '/api/webhooks/waha'
    | '/sitemap/catalog/$'
    | '/.well-known/api-catalog'
    | '/.well-known/oauth-authorization-server'
    | '/.well-known/oauth-protected-resource'
    | '/.well-known/openid-configuration'
    | '/admin'
    | '/alerts'
    | '/collections'
    | '/community'
    | '/discover'
    | '/forgot-password'
    | '/genres'
    | '/lists'
    | '/login'
    | '/my-offers'
    | '/notifications'
    | '/offers'
    | '/partners'
    | '/reset-password'
    | '/search'
    | '/settings'
    | '/stories'
    | '/styles'
    | '/taste'
    | '/telegram'
    | '/welcome'
    | '/whatsapp'
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/onboarding'
    | '/sitemap/catalog-offers.xml'
    | '/sitemap/catalog.xml'
    | '/.well-known/oauth-authorization-server/api/auth'
    | '/.well-known/oauth-protected-resource/api/mcp'
    | '/admin/requests/new'
    | '/.well-known/mcp/server-card.json'
    | '/$lang/$family'
    | '/$lang/artists'
    | '/$lang/editorial'
    | '/$lang/garimpos'
    | '/admin/agents'
    | '/admin/channels'
    | '/admin/commands'
    | '/admin/feature-pages'
    | '/admin/offer-clicks'
    | '/admin/offers'
    | '/admin/requests'
    | '/admin/review'
    | '/admin/settings'
    | '/admin/telegram'
    | '/admin/users'
    | '/admin/whatsapp'
    | '/community/people'
    | '/lists/$id'
    | '/oauth/consent'
    | '/$lang/stores'
    | '/api/ads/customer-match.csv'
    | '/api/partners/offer-workbook'
    | '/$lang/$family/$slug/draft'
    | '/$lang/about/providers'
    | '/$lang/$family/$slug'
    | '/admin/offers/$offerId'
    | '/admin/requests/$requestId'
    | '/admin/users/$userId'
    | '/$lang/contact'
    | '/$lang/privacy'
    | '/$lang/terms'
    | '/$lang/pages/cd-price-alerts'
    | '/$lang/pages/vinyl-price-alerts'
    | '/api/internal/media/authorize-upload'
    | '/api/internal/media/commit-upload'
    | '/api/internal/media/source-references'
    | '/lists/$id/items/$itemId'
  id:
    | '__root__'
    | '/_about'
    | '/_app'
    | '/_home'
    | '/_legal'
    | '/_onboarding'
    | '/_pages'
    | '/health'
    | '/robots.txt'
    | '/sitemap.xml'
    | '/sitemap_index.xml'
    | '/stores'
    | '/_app/$lang'
    | '/_app/admin'
    | '/_app/lists'
    | '/_app/partners'
    | '/_pages/$lang'
    | '/api/mcp'
    | '/cdn/$'
    | '/sitemap/artists.xml'
    | '/sitemap/companies.xml'
    | '/sitemap/features.xml'
    | '/sitemap/listings.xml'
    | '/sitemap/lists.xml'
    | '/sitemap/posts.xml'
    | '/sitemap/releases.xml'
    | '/sitemap/static.xml'
    | '/sitemap/users.xml'
    | '/sitemap/works.xml'
    | '/unsubscribe/notifications'
    | '/_home/'
    | '/_about/about/providers'
    | '/_app/$lang/$family'
    | '/_app/album/$id'
    | '/_app/artist/$id'
    | '/_app/collection/$slug'
    | '/_app/collections/$slug'
    | '/_app/community/$id'
    | '/_app/company/$id'
    | '/_app/genre/$slug'
    | '/_app/genres/$slug'
    | '/_app/label/$id'
    | '/_app/listings/$id'
    | '/_app/lists/collection'
    | '/_app/partners/offers'
    | '/_app/post/$id'
    | '/_app/release/$id'
    | '/_app/stories/$slug'
    | '/_app/story/$slug'
    | '/_app/style/$slug'
    | '/_app/styles/$slug'
    | '/_app/u/$username'
    | '/_app/work/$id'
    | '/_pages/$lang/_about'
    | '/_pages/$lang/_legal'
    | '/api/auth/$'
    | '/api/discogs/callback'
    | '/api/lastfm/callback'
    | '/api/push/subscription'
    | '/api/rpc/$'
    | '/api/unsubscribe/notifications'
    | '/api/webhooks/rastr'
    | '/api/webhooks/resend'
    | '/api/webhooks/telegram'
    | '/api/webhooks/waha'
    | '/sitemap/catalog/$'
    | '/.well-known/api-catalog/'
    | '/.well-known/oauth-authorization-server/'
    | '/.well-known/oauth-protected-resource/'
    | '/.well-known/openid-configuration/'
    | '/_app/admin/'
    | '/_app/alerts/'
    | '/_app/collections/'
    | '/_app/community/'
    | '/_app/discover/'
    | '/_app/forgot-password/'
    | '/_app/genres/'
    | '/_app/lists/'
    | '/_app/login/'
    | '/_app/my-offers/'
    | '/_app/notifications/'
    | '/_app/offers/'
    | '/_app/partners/'
    | '/_app/reset-password/'
    | '/_app/search/'
    | '/_app/settings/'
    | '/_app/stories/'
    | '/_app/styles/'
    | '/_app/taste/'
    | '/_app/telegram/'
    | '/_app/welcome/'
    | '/_app/whatsapp/'
    | '/_legal/contact/'
    | '/_legal/privacy/'
    | '/_legal/terms/'
    | '/_onboarding/onboarding/'
    | '/sitemap/catalog-offers.xml/'
    | '/sitemap/catalog.xml/'
    | '/_app/$lang/$family/$slug'
    | '/.well-known/oauth-authorization-server/api/auth'
    | '/.well-known/oauth-protected-resource/api/mcp'
    | '/_app/admin/requests/new'
    | '/.well-known/mcp/server-card.json/'
    | '/_app/$lang/$family/'
    | '/_app/$lang/artists/'
    | '/_app/$lang/editorial/'
    | '/_app/$lang/garimpos/'
    | '/_app/admin/agents/'
    | '/_app/admin/channels/'
    | '/_app/admin/commands/'
    | '/_app/admin/feature-pages/'
    | '/_app/admin/offer-clicks/'
    | '/_app/admin/offers/'
    | '/_app/admin/requests/'
    | '/_app/admin/review/'
    | '/_app/admin/settings/'
    | '/_app/admin/telegram/'
    | '/_app/admin/users/'
    | '/_app/admin/whatsapp/'
    | '/_app/community/people/'
    | '/_app/lists/$id/'
    | '/_app/oauth/consent/'
    | '/_pages/$lang/stores/'
    | '/api/ads/customer-match.csv/'
    | '/api/partners/offer-workbook/'
    | '/_app/$lang/$family/$slug/draft'
    | '/_pages/$lang/_about/about/providers'
    | '/_app/$lang/$family/$slug/'
    | '/_app/admin/offers/$offerId/'
    | '/_app/admin/requests/$requestId/'
    | '/_app/admin/users/$userId/'
    | '/_pages/$lang/_legal/contact/'
    | '/_pages/$lang/_legal/privacy/'
    | '/_pages/$lang/_legal/terms/'
    | '/_pages/$lang/pages/cd-price-alerts/'
    | '/_pages/$lang/pages/vinyl-price-alerts/'
    | '/api/internal/media/authorize-upload/'
    | '/api/internal/media/commit-upload/'
    | '/api/internal/media/source-references/'
    | '/_app/lists/$id/items/$itemId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AboutRoute: typeof AboutRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  HomeRoute: typeof HomeRouteWithChildren
  LegalRoute: typeof LegalRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PagesRoute: typeof PagesRouteWithChildren
  HealthRoute: typeof HealthRoute
  RobotsDottxtRoute: typeof RobotsDottxtRoute
  SitemapDotxmlRoute: typeof SitemapDotxmlRoute
  Sitemap_indexDotxmlRoute: typeof Sitemap_indexDotxmlRoute
  StoresRoute: typeof StoresRoute
  ApiMcpRoute: typeof ApiMcpRoute
  CdnSplatRoute: typeof CdnSplatRoute
  SitemapArtistsDotxmlRoute: typeof SitemapArtistsDotxmlRoute
  SitemapCompaniesDotxmlRoute: typeof SitemapCompaniesDotxmlRoute
  SitemapFeaturesDotxmlRoute: typeof SitemapFeaturesDotxmlRoute
  SitemapListingsDotxmlRoute: typeof SitemapListingsDotxmlRoute
  SitemapListsDotxmlRoute: typeof SitemapListsDotxmlRoute
  SitemapPostsDotxmlRoute: typeof SitemapPostsDotxmlRoute
  SitemapReleasesDotxmlRoute: typeof SitemapReleasesDotxmlRoute
  SitemapStaticDotxmlRoute: typeof SitemapStaticDotxmlRoute
  SitemapUsersDotxmlRoute: typeof SitemapUsersDotxmlRoute
  SitemapWorksDotxmlRoute: typeof SitemapWorksDotxmlRoute
  UnsubscribeNotificationsRoute: typeof UnsubscribeNotificationsRoute
  ApiAuthSplatRoute: typeof ApiAuthSplatRoute
  ApiDiscogsCallbackRoute: typeof ApiDiscogsCallbackRoute
  ApiLastfmCallbackRoute: typeof ApiLastfmCallbackRoute
  ApiPushSubscriptionRoute: typeof ApiPushSubscriptionRoute
  ApiRpcSplatRoute: typeof ApiRpcSplatRoute
  ApiUnsubscribeNotificationsRoute: typeof ApiUnsubscribeNotificationsRoute
  ApiWebhooksRastrRoute: typeof ApiWebhooksRastrRoute
  ApiWebhooksResendRoute: typeof ApiWebhooksResendRoute
  ApiWebhooksTelegramRoute: typeof ApiWebhooksTelegramRoute
  ApiWebhooksWahaRoute: typeof ApiWebhooksWahaRoute
  SitemapCatalogSplatRoute: typeof SitemapCatalogSplatRoute
  DotwellKnownApiCatalogIndexRoute: typeof DotwellKnownApiCatalogIndexRoute
  DotwellKnownOauthAuthorizationServerIndexRoute: typeof DotwellKnownOauthAuthorizationServerIndexRoute
  DotwellKnownOauthProtectedResourceIndexRoute: typeof DotwellKnownOauthProtectedResourceIndexRoute
  DotwellKnownOpenidConfigurationIndexRoute: typeof DotwellKnownOpenidConfigurationIndexRoute
  SitemapCatalogOffersDotxmlIndexRoute: typeof SitemapCatalogOffersDotxmlIndexRoute
  SitemapCatalogDotxmlIndexRoute: typeof SitemapCatalogDotxmlIndexRoute
  DotwellKnownOauthAuthorizationServerApiAuthRoute: typeof DotwellKnownOauthAuthorizationServerApiAuthRoute
  DotwellKnownOauthProtectedResourceApiMcpRoute: typeof DotwellKnownOauthProtectedResourceApiMcpRoute
  DotwellKnownMcpServerCardDotjsonIndexRoute: typeof DotwellKnownMcpServerCardDotjsonIndexRoute
  ApiAdsCustomerMatchDotcsvIndexRoute: typeof ApiAdsCustomerMatchDotcsvIndexRoute
  ApiPartnersOfferWorkbookIndexRoute: typeof ApiPartnersOfferWorkbookIndexRoute
  ApiInternalMediaAuthorizeUploadIndexRoute: typeof ApiInternalMediaAuthorizeUploadIndexRoute
  ApiInternalMediaCommitUploadIndexRoute: typeof ApiInternalMediaCommitUploadIndexRoute
  ApiInternalMediaSourceReferencesIndexRoute: typeof ApiInternalMediaSourceReferencesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_about': {
      id: '/_about'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_home': {
      id: '/_home'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_legal': {
      id: '/_legal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_pages': {
      id: '/_pages'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/robots.txt': {
      id: '/robots.txt'
      path: '/robots.txt'
      fullPath: '/robots.txt'
      preLoaderRoute: typeof RobotsDottxtRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap.xml': {
      id: '/sitemap.xml'
      path: '/sitemap.xml'
      fullPath: '/sitemap.xml'
      preLoaderRoute: typeof SitemapDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap_index.xml': {
      id: '/sitemap_index.xml'
      path: '/sitemap_index.xml'
      fullPath: '/sitemap_index.xml'
      preLoaderRoute: typeof Sitemap_indexDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stores': {
      id: '/stores'
      path: '/stores'
      fullPath: '/stores'
      preLoaderRoute: typeof StoresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$lang': {
      id: '/_app/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof AppLangRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists': {
      id: '/_app/lists'
      path: '/lists'
      fullPath: '/lists'
      preLoaderRoute: typeof AppListsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/partners': {
      id: '/_app/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof AppPartnersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_home/': {
      id: '/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_pages/$lang': {
      id: '/_pages/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof PagesLangRouteImport
      parentRoute: typeof PagesRoute
    }
    '/api/mcp': {
      id: '/api/mcp'
      path: '/api/mcp'
      fullPath: '/api/mcp'
      preLoaderRoute: typeof ApiMcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cdn/$': {
      id: '/cdn/$'
      path: '/cdn/$'
      fullPath: '/cdn/$'
      preLoaderRoute: typeof CdnSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/artists.xml': {
      id: '/sitemap/artists.xml'
      path: '/sitemap/artists.xml'
      fullPath: '/sitemap/artists.xml'
      preLoaderRoute: typeof SitemapArtistsDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/companies.xml': {
      id: '/sitemap/companies.xml'
      path: '/sitemap/companies.xml'
      fullPath: '/sitemap/companies.xml'
      preLoaderRoute: typeof SitemapCompaniesDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/features.xml': {
      id: '/sitemap/features.xml'
      path: '/sitemap/features.xml'
      fullPath: '/sitemap/features.xml'
      preLoaderRoute: typeof SitemapFeaturesDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/listings.xml': {
      id: '/sitemap/listings.xml'
      path: '/sitemap/listings.xml'
      fullPath: '/sitemap/listings.xml'
      preLoaderRoute: typeof SitemapListingsDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/lists.xml': {
      id: '/sitemap/lists.xml'
      path: '/sitemap/lists.xml'
      fullPath: '/sitemap/lists.xml'
      preLoaderRoute: typeof SitemapListsDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/posts.xml': {
      id: '/sitemap/posts.xml'
      path: '/sitemap/posts.xml'
      fullPath: '/sitemap/posts.xml'
      preLoaderRoute: typeof SitemapPostsDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/releases.xml': {
      id: '/sitemap/releases.xml'
      path: '/sitemap/releases.xml'
      fullPath: '/sitemap/releases.xml'
      preLoaderRoute: typeof SitemapReleasesDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/static.xml': {
      id: '/sitemap/static.xml'
      path: '/sitemap/static.xml'
      fullPath: '/sitemap/static.xml'
      preLoaderRoute: typeof SitemapStaticDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/users.xml': {
      id: '/sitemap/users.xml'
      path: '/sitemap/users.xml'
      fullPath: '/sitemap/users.xml'
      preLoaderRoute: typeof SitemapUsersDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/works.xml': {
      id: '/sitemap/works.xml'
      path: '/sitemap/works.xml'
      fullPath: '/sitemap/works.xml'
      preLoaderRoute: typeof SitemapWorksDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe/notifications': {
      id: '/unsubscribe/notifications'
      path: '/unsubscribe/notifications'
      fullPath: '/unsubscribe/notifications'
      preLoaderRoute: typeof UnsubscribeNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/.well-known/api-catalog/': {
      id: '/.well-known/api-catalog/'
      path: '/.well-known/api-catalog'
      fullPath: '/.well-known/api-catalog/'
      preLoaderRoute: typeof DotwellKnownApiCatalogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/.well-known/oauth-authorization-server/': {
      id: '/.well-known/oauth-authorization-server/'
      path: '/.well-known/oauth-authorization-server'
      fullPath: '/.well-known/oauth-authorization-server/'
      preLoaderRoute: typeof DotwellKnownOauthAuthorizationServerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/.well-known/oauth-protected-resource/': {
      id: '/.well-known/oauth-protected-resource/'
      path: '/.well-known/oauth-protected-resource'
      fullPath: '/.well-known/oauth-protected-resource/'
      preLoaderRoute: typeof DotwellKnownOauthProtectedResourceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/.well-known/openid-configuration/': {
      id: '/.well-known/openid-configuration/'
      path: '/.well-known/openid-configuration'
      fullPath: '/.well-known/openid-configuration/'
      preLoaderRoute: typeof DotwellKnownOpenidConfigurationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_about/about/providers': {
      id: '/_about/about/providers'
      path: '/about/providers'
      fullPath: '/about/providers'
      preLoaderRoute: typeof AboutAboutProvidersRouteImport
      parentRoute: typeof AboutRoute
    }
    '/_app/$lang/$family': {
      id: '/_app/$lang/$family'
      path: '/$family'
      fullPath: '/$lang/$family'
      preLoaderRoute: typeof AppLangFamilyRouteImport
      parentRoute: typeof AppLangRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/album/$id': {
      id: '/_app/album/$id'
      path: '/album/$id'
      fullPath: '/album/$id'
      preLoaderRoute: typeof AppAlbumIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts/': {
      id: '/_app/alerts/'
      path: '/alerts'
      fullPath: '/alerts/'
      preLoaderRoute: typeof AppAlertsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/artist/$id': {
      id: '/_app/artist/$id'
      path: '/artist/$id'
      fullPath: '/artist/$id'
      preLoaderRoute: typeof AppArtistIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collection/$slug': {
      id: '/_app/collection/$slug'
      path: '/collection/$slug'
      fullPath: '/collection/$slug'
      preLoaderRoute: typeof AppCollectionSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collections/': {
      id: '/_app/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof AppCollectionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collections/$slug': {
      id: '/_app/collections/$slug'
      path: '/collections/$slug'
      fullPath: '/collections/$slug'
      preLoaderRoute: typeof AppCollectionsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/community/': {
      id: '/_app/community/'
      path: '/community'
      fullPath: '/community/'
      preLoaderRoute: typeof AppCommunityIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/community/$id': {
      id: '/_app/community/$id'
      path: '/community/$id'
      fullPath: '/community/$id'
      preLoaderRoute: typeof AppCommunityIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/company/$id': {
      id: '/_app/company/$id'
      path: '/company/$id'
      fullPath: '/company/$id'
      preLoaderRoute: typeof AppCompanyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/discover/': {
      id: '/_app/discover/'
      path: '/discover'
      fullPath: '/discover/'
      preLoaderRoute: typeof AppDiscoverIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forgot-password/': {
      id: '/_app/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof AppForgotPasswordIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/genre/$slug': {
      id: '/_app/genre/$slug'
      path: '/genre/$slug'
      fullPath: '/genre/$slug'
      preLoaderRoute: typeof AppGenreSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/genres/': {
      id: '/_app/genres/'
      path: '/genres'
      fullPath: '/genres/'
      preLoaderRoute: typeof AppGenresIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/genres/$slug': {
      id: '/_app/genres/$slug'
      path: '/genres/$slug'
      fullPath: '/genres/$slug'
      preLoaderRoute: typeof AppGenresSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/label/$id': {
      id: '/_app/label/$id'
      path: '/label/$id'
      fullPath: '/label/$id'
      preLoaderRoute: typeof AppLabelIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/listings/$id': {
      id: '/_app/listings/$id'
      path: '/listings/$id'
      fullPath: '/listings/$id'
      preLoaderRoute: typeof AppListingsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists/': {
      id: '/_app/lists/'
      path: '/'
      fullPath: '/lists/'
      preLoaderRoute: typeof AppListsIndexRouteImport
      parentRoute: typeof AppListsRoute
    }
    '/_app/lists/collection': {
      id: '/_app/lists/collection'
      path: '/collection'
      fullPath: '/lists/collection'
      preLoaderRoute: typeof AppListsCollectionRouteImport
      parentRoute: typeof AppListsRoute
    }
    '/_app/login/': {
      id: '/_app/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AppLoginIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-offers/': {
      id: '/_app/my-offers/'
      path: '/my-offers'
      fullPath: '/my-offers/'
      preLoaderRoute: typeof AppMyOffersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications/': {
      id: '/_app/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AppNotificationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offers/': {
      id: '/_app/offers/'
      path: '/offers'
      fullPath: '/offers/'
      preLoaderRoute: typeof AppOffersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/partners/': {
      id: '/_app/partners/'
      path: '/'
      fullPath: '/partners/'
      preLoaderRoute: typeof AppPartnersIndexRouteImport
      parentRoute: typeof AppPartnersRoute
    }
    '/_app/partners/offers': {
      id: '/_app/partners/offers'
      path: '/offers'
      fullPath: '/partners/offers'
      preLoaderRoute: typeof AppPartnersOffersRouteImport
      parentRoute: typeof AppPartnersRoute
    }
    '/_app/post/$id': {
      id: '/_app/post/$id'
      path: '/post/$id'
      fullPath: '/post/$id'
      preLoaderRoute: typeof AppPostIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/release/$id': {
      id: '/_app/release/$id'
      path: '/release/$id'
      fullPath: '/release/$id'
      preLoaderRoute: typeof AppReleaseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reset-password/': {
      id: '/_app/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof AppResetPasswordIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search/': {
      id: '/_app/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AppSearchIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stories/': {
      id: '/_app/stories/'
      path: '/stories'
      fullPath: '/stories/'
      preLoaderRoute: typeof AppStoriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stories/$slug': {
      id: '/_app/stories/$slug'
      path: '/stories/$slug'
      fullPath: '/stories/$slug'
      preLoaderRoute: typeof AppStoriesSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/story/$slug': {
      id: '/_app/story/$slug'
      path: '/story/$slug'
      fullPath: '/story/$slug'
      preLoaderRoute: typeof AppStorySlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/style/$slug': {
      id: '/_app/style/$slug'
      path: '/style/$slug'
      fullPath: '/style/$slug'
      preLoaderRoute: typeof AppStyleSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/styles/': {
      id: '/_app/styles/'
      path: '/styles'
      fullPath: '/styles/'
      preLoaderRoute: typeof AppStylesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/styles/$slug': {
      id: '/_app/styles/$slug'
      path: '/styles/$slug'
      fullPath: '/styles/$slug'
      preLoaderRoute: typeof AppStylesSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/taste/': {
      id: '/_app/taste/'
      path: '/taste'
      fullPath: '/taste/'
      preLoaderRoute: typeof AppTasteIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/telegram/': {
      id: '/_app/telegram/'
      path: '/telegram'
      fullPath: '/telegram/'
      preLoaderRoute: typeof AppTelegramIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/u/$username': {
      id: '/_app/u/$username'
      path: '/u/$username'
      fullPath: '/u/$username'
      preLoaderRoute: typeof AppUUsernameRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/welcome/': {
      id: '/_app/welcome/'
      path: '/welcome'
      fullPath: '/welcome/'
      preLoaderRoute: typeof AppWelcomeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/whatsapp/': {
      id: '/_app/whatsapp/'
      path: '/whatsapp'
      fullPath: '/whatsapp/'
      preLoaderRoute: typeof AppWhatsappIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/work/$id': {
      id: '/_app/work/$id'
      path: '/work/$id'
      fullPath: '/work/$id'
      preLoaderRoute: typeof AppWorkIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_legal/contact/': {
      id: '/_legal/contact/'
      path: '/contact'
      fullPath: '/contact/'
      preLoaderRoute: typeof LegalContactIndexRouteImport
      parentRoute: typeof LegalRoute
    }
    '/_legal/privacy/': {
      id: '/_legal/privacy/'
      path: '/privacy'
      fullPath: '/privacy/'
      preLoaderRoute: typeof LegalPrivacyIndexRouteImport
      parentRoute: typeof LegalRoute
    }
    '/_legal/terms/': {
      id: '/_legal/terms/'
      path: '/terms'
      fullPath: '/terms/'
      preLoaderRoute: typeof LegalTermsIndexRouteImport
      parentRoute: typeof LegalRoute
    }
    '/_onboarding/onboarding/': {
      id: '/_onboarding/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingOnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_pages/$lang/_about': {
      id: '/_pages/$lang/_about'
      path: ''
      fullPath: '/$lang'
      preLoaderRoute: typeof PagesLangAboutRouteImport
      parentRoute: typeof PagesLangRoute
    }
    '/_pages/$lang/_legal': {
      id: '/_pages/$lang/_legal'
      path: ''
      fullPath: '/$lang'
      preLoaderRoute: typeof PagesLangLegalRouteImport
      parentRoute: typeof PagesLangRoute
    }
    '/api/auth/$': {
      id: '/api/auth/$'
      path: '/api/auth/$'
      fullPath: '/api/auth/$'
      preLoaderRoute: typeof ApiAuthSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/discogs/callback': {
      id: '/api/discogs/callback'
      path: '/api/discogs/callback'
      fullPath: '/api/discogs/callback'
      preLoaderRoute: typeof ApiDiscogsCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/lastfm/callback': {
      id: '/api/lastfm/callback'
      path: '/api/lastfm/callback'
      fullPath: '/api/lastfm/callback'
      preLoaderRoute: typeof ApiLastfmCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/push/subscription': {
      id: '/api/push/subscription'
      path: '/api/push/subscription'
      fullPath: '/api/push/subscription'
      preLoaderRoute: typeof ApiPushSubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/rpc/$': {
      id: '/api/rpc/$'
      path: '/api/rpc/$'
      fullPath: '/api/rpc/$'
      preLoaderRoute: typeof ApiRpcSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/unsubscribe/notifications': {
      id: '/api/unsubscribe/notifications'
      path: '/api/unsubscribe/notifications'
      fullPath: '/api/unsubscribe/notifications'
      preLoaderRoute: typeof ApiUnsubscribeNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/webhooks/rastr': {
      id: '/api/webhooks/rastr'
      path: '/api/webhooks/rastr'
      fullPath: '/api/webhooks/rastr'
      preLoaderRoute: typeof ApiWebhooksRastrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/webhooks/resend': {
      id: '/api/webhooks/resend'
      path: '/api/webhooks/resend'
      fullPath: '/api/webhooks/resend'
      preLoaderRoute: typeof ApiWebhooksResendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/webhooks/telegram': {
      id: '/api/webhooks/telegram'
      path: '/api/webhooks/telegram'
      fullPath: '/api/webhooks/telegram'
      preLoaderRoute: typeof ApiWebhooksTelegramRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/webhooks/waha': {
      id: '/api/webhooks/waha'
      path: '/api/webhooks/waha'
      fullPath: '/api/webhooks/waha'
      preLoaderRoute: typeof ApiWebhooksWahaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/catalog-offers.xml/': {
      id: '/sitemap/catalog-offers.xml/'
      path: '/sitemap/catalog-offers.xml'
      fullPath: '/sitemap/catalog-offers.xml/'
      preLoaderRoute: typeof SitemapCatalogOffersDotxmlIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/catalog.xml/': {
      id: '/sitemap/catalog.xml/'
      path: '/sitemap/catalog.xml'
      fullPath: '/sitemap/catalog.xml/'
      preLoaderRoute: typeof SitemapCatalogDotxmlIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/catalog/$': {
      id: '/sitemap/catalog/$'
      path: '/sitemap/catalog/$'
      fullPath: '/sitemap/catalog/$'
      preLoaderRoute: typeof SitemapCatalogSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/.well-known/mcp/server-card.json/': {
      id: '/.well-known/mcp/server-card.json/'
      path: '/.well-known/mcp/server-card.json'
      fullPath: '/.well-known/mcp/server-card.json/'
      preLoaderRoute: typeof DotwellKnownMcpServerCardDotjsonIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/.well-known/oauth-authorization-server/api/auth': {
      id: '/.well-known/oauth-authorization-server/api/auth'
      path: '/.well-known/oauth-authorization-server/api/auth'
      fullPath: '/.well-known/oauth-authorization-server/api/auth'
      preLoaderRoute: typeof DotwellKnownOauthAuthorizationServerApiAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/.well-known/oauth-protected-resource/api/mcp': {
      id: '/.well-known/oauth-protected-resource/api/mcp'
      path: '/.well-known/oauth-protected-resource/api/mcp'
      fullPath: '/.well-known/oauth-protected-resource/api/mcp'
      preLoaderRoute: typeof DotwellKnownOauthProtectedResourceApiMcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$lang/$family/': {
      id: '/_app/$lang/$family/'
      path: '/'
      fullPath: '/$lang/$family/'
      preLoaderRoute: typeof AppLangFamilyIndexRouteImport
      parentRoute: typeof AppLangFamilyRoute
    }
    '/_app/$lang/$family/$slug': {
      id: '/_app/$lang/$family/$slug'
      path: '/$slug'
      fullPath: '/$lang/$family/$slug'
      preLoaderRoute: typeof AppLangFamilySlugRouteRouteImport
      parentRoute: typeof AppLangFamilyRoute
    }
    '/_app/$lang/artists/': {
      id: '/_app/$lang/artists/'
      path: '/artists'
      fullPath: '/$lang/artists/'
      preLoaderRoute: typeof AppLangArtistsIndexRouteImport
      parentRoute: typeof AppLangRoute
    }
    '/_app/$lang/editorial/': {
      id: '/_app/$lang/editorial/'
      path: '/editorial'
      fullPath: '/$lang/editorial/'
      preLoaderRoute: typeof AppLangEditorialIndexRouteImport
      parentRoute: typeof AppLangRoute
    }
    '/_app/$lang/garimpos/': {
      id: '/_app/$lang/garimpos/'
      path: '/garimpos'
      fullPath: '/$lang/garimpos/'
      preLoaderRoute: typeof AppLangGarimposIndexRouteImport
      parentRoute: typeof AppLangRoute
    }
    '/_app/admin/agents/': {
      id: '/_app/admin/agents/'
      path: '/agents'
      fullPath: '/admin/agents/'
      preLoaderRoute: typeof AppAdminAgentsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/channels/': {
      id: '/_app/admin/channels/'
      path: '/channels'
      fullPath: '/admin/channels/'
      preLoaderRoute: typeof AppAdminChannelsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/commands/': {
      id: '/_app/admin/commands/'
      path: '/commands'
      fullPath: '/admin/commands/'
      preLoaderRoute: typeof AppAdminCommandsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/feature-pages/': {
      id: '/_app/admin/feature-pages/'
      path: '/feature-pages'
      fullPath: '/admin/feature-pages/'
      preLoaderRoute: typeof AppAdminFeaturePagesIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/offer-clicks/': {
      id: '/_app/admin/offer-clicks/'
      path: '/offer-clicks'
      fullPath: '/admin/offer-clicks/'
      preLoaderRoute: typeof AppAdminOfferClicksIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/offers/': {
      id: '/_app/admin/offers/'
      path: '/offers'
      fullPath: '/admin/offers/'
      preLoaderRoute: typeof AppAdminOffersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/requests/': {
      id: '/_app/admin/requests/'
      path: '/requests'
      fullPath: '/admin/requests/'
      preLoaderRoute: typeof AppAdminRequestsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/requests/new': {
      id: '/_app/admin/requests/new'
      path: '/requests/new'
      fullPath: '/admin/requests/new'
      preLoaderRoute: typeof AppAdminRequestsNewRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/review/': {
      id: '/_app/admin/review/'
      path: '/review'
      fullPath: '/admin/review/'
      preLoaderRoute: typeof AppAdminReviewIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/settings/': {
      id: '/_app/admin/settings/'
      path: '/settings'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AppAdminSettingsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/telegram/': {
      id: '/_app/admin/telegram/'
      path: '/telegram'
      fullPath: '/admin/telegram/'
      preLoaderRoute: typeof AppAdminTelegramIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/whatsapp/': {
      id: '/_app/admin/whatsapp/'
      path: '/whatsapp'
      fullPath: '/admin/whatsapp/'
      preLoaderRoute: typeof AppAdminWhatsappIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/community/people/': {
      id: '/_app/community/people/'
      path: '/community/people'
      fullPath: '/community/people/'
      preLoaderRoute: typeof AppCommunityPeopleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists/$id/': {
      id: '/_app/lists/$id/'
      path: '/$id'
      fullPath: '/lists/$id/'
      preLoaderRoute: typeof AppListsIdIndexRouteImport
      parentRoute: typeof AppListsRoute
    }
    '/_app/oauth/consent/': {
      id: '/_app/oauth/consent/'
      path: '/oauth/consent'
      fullPath: '/oauth/consent/'
      preLoaderRoute: typeof AppOauthConsentIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_pages/$lang/stores/': {
      id: '/_pages/$lang/stores/'
      path: '/stores'
      fullPath: '/$lang/stores/'
      preLoaderRoute: typeof PagesLangStoresIndexRouteImport
      parentRoute: typeof PagesLangRoute
    }
    '/api/ads/customer-match.csv/': {
      id: '/api/ads/customer-match.csv/'
      path: '/api/ads/customer-match.csv'
      fullPath: '/api/ads/customer-match.csv/'
      preLoaderRoute: typeof ApiAdsCustomerMatchDotcsvIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/partners/offer-workbook/': {
      id: '/api/partners/offer-workbook/'
      path: '/api/partners/offer-workbook'
      fullPath: '/api/partners/offer-workbook/'
      preLoaderRoute: typeof ApiPartnersOfferWorkbookIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$lang/$family/$slug/': {
      id: '/_app/$lang/$family/$slug/'
      path: '/'
      fullPath: '/$lang/$family/$slug/'
      preLoaderRoute: typeof AppLangFamilySlugIndexRouteImport
      parentRoute: typeof AppLangFamilySlugRouteRoute
    }
    '/_app/$lang/$family/$slug/draft': {
      id: '/_app/$lang/$family/$slug/draft'
      path: '/draft'
      fullPath: '/$lang/$family/$slug/draft'
      preLoaderRoute: typeof AppLangFamilySlugDraftRouteImport
      parentRoute: typeof AppLangFamilySlugRouteRoute
    }
    '/_app/admin/offers/$offerId/': {
      id: '/_app/admin/offers/$offerId/'
      path: '/offers/$offerId'
      fullPath: '/admin/offers/$offerId/'
      preLoaderRoute: typeof AppAdminOffersOfferIdIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/requests/$requestId/': {
      id: '/_app/admin/requests/$requestId/'
      path: '/requests/$requestId'
      fullPath: '/admin/requests/$requestId/'
      preLoaderRoute: typeof AppAdminRequestsRequestIdIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/$userId/': {
      id: '/_app/admin/users/$userId/'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId/'
      preLoaderRoute: typeof AppAdminUsersUserIdIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_pages/$lang/_about/about/providers': {
      id: '/_pages/$lang/_about/about/providers'
      path: '/about/providers'
      fullPath: '/$lang/about/providers'
      preLoaderRoute: typeof PagesLangAboutAboutProvidersRouteImport
      parentRoute: typeof PagesLangAboutRoute
    }
    '/_pages/$lang/_legal/contact/': {
      id: '/_pages/$lang/_legal/contact/'
      path: '/contact'
      fullPath: '/$lang/contact/'
      preLoaderRoute: typeof PagesLangLegalContactIndexRouteImport
      parentRoute: typeof PagesLangLegalRoute
    }
    '/_pages/$lang/_legal/privacy/': {
      id: '/_pages/$lang/_legal/privacy/'
      path: '/privacy'
      fullPath: '/$lang/privacy/'
      preLoaderRoute: typeof PagesLangLegalPrivacyIndexRouteImport
      parentRoute: typeof PagesLangLegalRoute
    }
    '/_pages/$lang/_legal/terms/': {
      id: '/_pages/$lang/_legal/terms/'
      path: '/terms'
      fullPath: '/$lang/terms/'
      preLoaderRoute: typeof PagesLangLegalTermsIndexRouteImport
      parentRoute: typeof PagesLangLegalRoute
    }
    '/_pages/$lang/pages/cd-price-alerts/': {
      id: '/_pages/$lang/pages/cd-price-alerts/'
      path: '/pages/cd-price-alerts'
      fullPath: '/$lang/pages/cd-price-alerts/'
      preLoaderRoute: typeof PagesLangPagesCdPriceAlertsIndexRouteImport
      parentRoute: typeof PagesLangRoute
    }
    '/_pages/$lang/pages/vinyl-price-alerts/': {
      id: '/_pages/$lang/pages/vinyl-price-alerts/'
      path: '/pages/vinyl-price-alerts'
      fullPath: '/$lang/pages/vinyl-price-alerts/'
      preLoaderRoute: typeof PagesLangPagesVinylPriceAlertsIndexRouteImport
      parentRoute: typeof PagesLangRoute
    }
    '/api/internal/media/authorize-upload/': {
      id: '/api/internal/media/authorize-upload/'
      path: '/api/internal/media/authorize-upload'
      fullPath: '/api/internal/media/authorize-upload/'
      preLoaderRoute: typeof ApiInternalMediaAuthorizeUploadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/internal/media/commit-upload/': {
      id: '/api/internal/media/commit-upload/'
      path: '/api/internal/media/commit-upload'
      fullPath: '/api/internal/media/commit-upload/'
      preLoaderRoute: typeof ApiInternalMediaCommitUploadIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/internal/media/source-references/': {
      id: '/api/internal/media/source-references/'
      path: '/api/internal/media/source-references'
      fullPath: '/api/internal/media/source-references/'
      preLoaderRoute: typeof ApiInternalMediaSourceReferencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/lists/$id/items/$itemId/': {
      id: '/_app/lists/$id/items/$itemId/'
      path: '/$id/items/$itemId'
      fullPath: '/lists/$id/items/$itemId/'
      preLoaderRoute: typeof AppListsIdItemsItemIdIndexRouteImport
      parentRoute: typeof AppListsRoute
    }
  }
}

interface AboutRouteChildren {
  AboutAboutProvidersRoute: typeof AboutAboutProvidersRoute
}

const AboutRouteChildren: AboutRouteChildren = {
  AboutAboutProvidersRoute: AboutAboutProvidersRoute,
}

const AboutRouteWithChildren = AboutRoute._addFileChildren(AboutRouteChildren)

interface AppLangFamilySlugRouteRouteChildren {
  AppLangFamilySlugDraftRoute: typeof AppLangFamilySlugDraftRoute
  AppLangFamilySlugIndexRoute: typeof AppLangFamilySlugIndexRoute
}

const AppLangFamilySlugRouteRouteChildren: AppLangFamilySlugRouteRouteChildren =
  {
    AppLangFamilySlugDraftRoute: AppLangFamilySlugDraftRoute,
    AppLangFamilySlugIndexRoute: AppLangFamilySlugIndexRoute,
  }

const AppLangFamilySlugRouteRouteWithChildren =
  AppLangFamilySlugRouteRoute._addFileChildren(
    AppLangFamilySlugRouteRouteChildren,
  )

interface AppLangFamilyRouteChildren {
  AppLangFamilySlugRouteRoute: typeof AppLangFamilySlugRouteRouteWithChildren
  AppLangFamilyIndexRoute: typeof AppLangFamilyIndexRoute
}

const AppLangFamilyRouteChildren: AppLangFamilyRouteChildren = {
  AppLangFamilySlugRouteRoute: AppLangFamilySlugRouteRouteWithChildren,
  AppLangFamilyIndexRoute: AppLangFamilyIndexRoute,
}

const AppLangFamilyRouteWithChildren = AppLangFamilyRoute._addFileChildren(
  AppLangFamilyRouteChildren,
)

interface AppLangRouteChildren {
  AppLangFamilyRoute: typeof AppLangFamilyRouteWithChildren
  AppLangArtistsIndexRoute: typeof AppLangArtistsIndexRoute
  AppLangEditorialIndexRoute: typeof AppLangEditorialIndexRoute
  AppLangGarimposIndexRoute: typeof AppLangGarimposIndexRoute
}

const AppLangRouteChildren: AppLangRouteChildren = {
  AppLangFamilyRoute: AppLangFamilyRouteWithChildren,
  AppLangArtistsIndexRoute: AppLangArtistsIndexRoute,
  AppLangEditorialIndexRoute: AppLangEditorialIndexRoute,
  AppLangGarimposIndexRoute: AppLangGarimposIndexRoute,
}

const AppLangRouteWithChildren =
  AppLangRoute._addFileChildren(AppLangRouteChildren)

interface AppAdminRouteChildren {
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminRequestsNewRoute: typeof AppAdminRequestsNewRoute
  AppAdminAgentsIndexRoute: typeof AppAdminAgentsIndexRoute
  AppAdminChannelsIndexRoute: typeof AppAdminChannelsIndexRoute
  AppAdminCommandsIndexRoute: typeof AppAdminCommandsIndexRoute
  AppAdminFeaturePagesIndexRoute: typeof AppAdminFeaturePagesIndexRoute
  AppAdminOfferClicksIndexRoute: typeof AppAdminOfferClicksIndexRoute
  AppAdminOffersIndexRoute: typeof AppAdminOffersIndexRoute
  AppAdminRequestsIndexRoute: typeof AppAdminRequestsIndexRoute
  AppAdminReviewIndexRoute: typeof AppAdminReviewIndexRoute
  AppAdminSettingsIndexRoute: typeof AppAdminSettingsIndexRoute
  AppAdminTelegramIndexRoute: typeof AppAdminTelegramIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
  AppAdminWhatsappIndexRoute: typeof AppAdminWhatsappIndexRoute
  AppAdminOffersOfferIdIndexRoute: typeof AppAdminOffersOfferIdIndexRoute
  AppAdminRequestsRequestIdIndexRoute: typeof AppAdminRequestsRequestIdIndexRoute
  AppAdminUsersUserIdIndexRoute: typeof AppAdminUsersUserIdIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminRequestsNewRoute: AppAdminRequestsNewRoute,
  AppAdminAgentsIndexRoute: AppAdminAgentsIndexRoute,
  AppAdminChannelsIndexRoute: AppAdminChannelsIndexRoute,
  AppAdminCommandsIndexRoute: AppAdminCommandsIndexRoute,
  AppAdminFeaturePagesIndexRoute: AppAdminFeaturePagesIndexRoute,
  AppAdminOfferClicksIndexRoute: AppAdminOfferClicksIndexRoute,
  AppAdminOffersIndexRoute: AppAdminOffersIndexRoute,
  AppAdminRequestsIndexRoute: AppAdminRequestsIndexRoute,
  AppAdminReviewIndexRoute: AppAdminReviewIndexRoute,
  AppAdminSettingsIndexRoute: AppAdminSettingsIndexRoute,
  AppAdminTelegramIndexRoute: AppAdminTelegramIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
  AppAdminWhatsappIndexRoute: AppAdminWhatsappIndexRoute,
  AppAdminOffersOfferIdIndexRoute: AppAdminOffersOfferIdIndexRoute,
  AppAdminRequestsRequestIdIndexRoute: AppAdminRequestsRequestIdIndexRoute,
  AppAdminUsersUserIdIndexRoute: AppAdminUsersUserIdIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppListsRouteChildren {
  AppListsCollectionRoute: typeof AppListsCollectionRoute
  AppListsIndexRoute: typeof AppListsIndexRoute
  AppListsIdIndexRoute: typeof AppListsIdIndexRoute
  AppListsIdItemsItemIdIndexRoute: typeof AppListsIdItemsItemIdIndexRoute
}

const AppListsRouteChildren: AppListsRouteChildren = {
  AppListsCollectionRoute: AppListsCollectionRoute,
  AppListsIndexRoute: AppListsIndexRoute,
  AppListsIdIndexRoute: AppListsIdIndexRoute,
  AppListsIdItemsItemIdIndexRoute: AppListsIdItemsItemIdIndexRoute,
}

const AppListsRouteWithChildren = AppListsRoute._addFileChildren(
  AppListsRouteChildren,
)

interface AppPartnersRouteChildren {
  AppPartnersOffersRoute: typeof AppPartnersOffersRoute
  AppPartnersIndexRoute: typeof AppPartnersIndexRoute
}

const AppPartnersRouteChildren: AppPartnersRouteChildren = {
  AppPartnersOffersRoute: AppPartnersOffersRoute,
  AppPartnersIndexRoute: AppPartnersIndexRoute,
}

const AppPartnersRouteWithChildren = AppPartnersRoute._addFileChildren(
  AppPartnersRouteChildren,
)

interface AppRouteChildren {
  AppLangRoute: typeof AppLangRouteWithChildren
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppListsRoute: typeof AppListsRouteWithChildren
  AppPartnersRoute: typeof AppPartnersRouteWithChildren
  AppAlbumIdRoute: typeof AppAlbumIdRoute
  AppArtistIdRoute: typeof AppArtistIdRoute
  AppCollectionSlugRoute: typeof AppCollectionSlugRoute
  AppCollectionsSlugRoute: typeof AppCollectionsSlugRoute
  AppCommunityIdRoute: typeof AppCommunityIdRoute
  AppCompanyIdRoute: typeof AppCompanyIdRoute
  AppGenreSlugRoute: typeof AppGenreSlugRoute
  AppGenresSlugRoute: typeof AppGenresSlugRoute
  AppLabelIdRoute: typeof AppLabelIdRoute
  AppListingsIdRoute: typeof AppListingsIdRoute
  AppPostIdRoute: typeof AppPostIdRoute
  AppReleaseIdRoute: typeof AppReleaseIdRoute
  AppStoriesSlugRoute: typeof AppStoriesSlugRoute
  AppStorySlugRoute: typeof AppStorySlugRoute
  AppStyleSlugRoute: typeof AppStyleSlugRoute
  AppStylesSlugRoute: typeof AppStylesSlugRoute
  AppUUsernameRoute: typeof AppUUsernameRoute
  AppWorkIdRoute: typeof AppWorkIdRoute
  AppAlertsIndexRoute: typeof AppAlertsIndexRoute
  AppCollectionsIndexRoute: typeof AppCollectionsIndexRoute
  AppCommunityIndexRoute: typeof AppCommunityIndexRoute
  AppDiscoverIndexRoute: typeof AppDiscoverIndexRoute
  AppForgotPasswordIndexRoute: typeof AppForgotPasswordIndexRoute
  AppGenresIndexRoute: typeof AppGenresIndexRoute
  AppLoginIndexRoute: typeof AppLoginIndexRoute
  AppMyOffersIndexRoute: typeof AppMyOffersIndexRoute
  AppNotificationsIndexRoute: typeof AppNotificationsIndexRoute
  AppOffersIndexRoute: typeof AppOffersIndexRoute
  AppResetPasswordIndexRoute: typeof AppResetPasswordIndexRoute
  AppSearchIndexRoute: typeof AppSearchIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppStoriesIndexRoute: typeof AppStoriesIndexRoute
  AppStylesIndexRoute: typeof AppStylesIndexRoute
  AppTasteIndexRoute: typeof AppTasteIndexRoute
  AppTelegramIndexRoute: typeof AppTelegramIndexRoute
  AppWelcomeIndexRoute: typeof AppWelcomeIndexRoute
  AppWhatsappIndexRoute: typeof AppWhatsappIndexRoute
  AppCommunityPeopleIndexRoute: typeof AppCommunityPeopleIndexRoute
  AppOauthConsentIndexRoute: typeof AppOauthConsentIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppLangRoute: AppLangRouteWithChildren,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppListsRoute: AppListsRouteWithChildren,
  AppPartnersRoute: AppPartnersRouteWithChildren,
  AppAlbumIdRoute: AppAlbumIdRoute,
  AppArtistIdRoute: AppArtistIdRoute,
  AppCollectionSlugRoute: AppCollectionSlugRoute,
  AppCollectionsSlugRoute: AppCollectionsSlugRoute,
  AppCommunityIdRoute: AppCommunityIdRoute,
  AppCompanyIdRoute: AppCompanyIdRoute,
  AppGenreSlugRoute: AppGenreSlugRoute,
  AppGenresSlugRoute: AppGenresSlugRoute,
  AppLabelIdRoute: AppLabelIdRoute,
  AppListingsIdRoute: AppListingsIdRoute,
  AppPostIdRoute: AppPostIdRoute,
  AppReleaseIdRoute: AppReleaseIdRoute,
  AppStoriesSlugRoute: AppStoriesSlugRoute,
  AppStorySlugRoute: AppStorySlugRoute,
  AppStyleSlugRoute: AppStyleSlugRoute,
  AppStylesSlugRoute: AppStylesSlugRoute,
  AppUUsernameRoute: AppUUsernameRoute,
  AppWorkIdRoute: AppWorkIdRoute,
  AppAlertsIndexRoute: AppAlertsIndexRoute,
  AppCollectionsIndexRoute: AppCollectionsIndexRoute,
  AppCommunityIndexRoute: AppCommunityIndexRoute,
  AppDiscoverIndexRoute: AppDiscoverIndexRoute,
  AppForgotPasswordIndexRoute: AppForgotPasswordIndexRoute,
  AppGenresIndexRoute: AppGenresIndexRoute,
  AppLoginIndexRoute: AppLoginIndexRoute,
  AppMyOffersIndexRoute: AppMyOffersIndexRoute,
  AppNotificationsIndexRoute: AppNotificationsIndexRoute,
  AppOffersIndexRoute: AppOffersIndexRoute,
  AppResetPasswordIndexRoute: AppResetPasswordIndexRoute,
  AppSearchIndexRoute: AppSearchIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppStoriesIndexRoute: AppStoriesIndexRoute,
  AppStylesIndexRoute: AppStylesIndexRoute,
  AppTasteIndexRoute: AppTasteIndexRoute,
  AppTelegramIndexRoute: AppTelegramIndexRoute,
  AppWelcomeIndexRoute: AppWelcomeIndexRoute,
  AppWhatsappIndexRoute: AppWhatsappIndexRoute,
  AppCommunityPeopleIndexRoute: AppCommunityPeopleIndexRoute,
  AppOauthConsentIndexRoute: AppOauthConsentIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface HomeRouteChildren {
  HomeIndexRoute: typeof HomeIndexRoute
}

const HomeRouteChildren: HomeRouteChildren = {
  HomeIndexRoute: HomeIndexRoute,
}

const HomeRouteWithChildren = HomeRoute._addFileChildren(HomeRouteChildren)

interface LegalRouteChildren {
  LegalContactIndexRoute: typeof LegalContactIndexRoute
  LegalPrivacyIndexRoute: typeof LegalPrivacyIndexRoute
  LegalTermsIndexRoute: typeof LegalTermsIndexRoute
}

const LegalRouteChildren: LegalRouteChildren = {
  LegalContactIndexRoute: LegalContactIndexRoute,
  LegalPrivacyIndexRoute: LegalPrivacyIndexRoute,
  LegalTermsIndexRoute: LegalTermsIndexRoute,
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

interface OnboardingRouteChildren {
  OnboardingOnboardingIndexRoute: typeof OnboardingOnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingOnboardingIndexRoute: OnboardingOnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface PagesLangAboutRouteChildren {
  PagesLangAboutAboutProvidersRoute: typeof PagesLangAboutAboutProvidersRoute
}

const PagesLangAboutRouteChildren: PagesLangAboutRouteChildren = {
  PagesLangAboutAboutProvidersRoute: PagesLangAboutAboutProvidersRoute,
}

const PagesLangAboutRouteWithChildren = PagesLangAboutRoute._addFileChildren(
  PagesLangAboutRouteChildren,
)

interface PagesLangLegalRouteChildren {
  PagesLangLegalContactIndexRoute: typeof PagesLangLegalContactIndexRoute
  PagesLangLegalPrivacyIndexRoute: typeof PagesLangLegalPrivacyIndexRoute
  PagesLangLegalTermsIndexRoute: typeof PagesLangLegalTermsIndexRoute
}

const PagesLangLegalRouteChildren: PagesLangLegalRouteChildren = {
  PagesLangLegalContactIndexRoute: PagesLangLegalContactIndexRoute,
  PagesLangLegalPrivacyIndexRoute: PagesLangLegalPrivacyIndexRoute,
  PagesLangLegalTermsIndexRoute: PagesLangLegalTermsIndexRoute,
}

const PagesLangLegalRouteWithChildren = PagesLangLegalRoute._addFileChildren(
  PagesLangLegalRouteChildren,
)

interface PagesLangRouteChildren {
  PagesLangAboutRoute: typeof PagesLangAboutRouteWithChildren
  PagesLangLegalRoute: typeof PagesLangLegalRouteWithChildren
  PagesLangStoresIndexRoute: typeof PagesLangStoresIndexRoute
  PagesLangPagesCdPriceAlertsIndexRoute: typeof PagesLangPagesCdPriceAlertsIndexRoute
  PagesLangPagesVinylPriceAlertsIndexRoute: typeof PagesLangPagesVinylPriceAlertsIndexRoute
}

const PagesLangRouteChildren: PagesLangRouteChildren = {
  PagesLangAboutRoute: PagesLangAboutRouteWithChildren,
  PagesLangLegalRoute: PagesLangLegalRouteWithChildren,
  PagesLangStoresIndexRoute: PagesLangStoresIndexRoute,
  PagesLangPagesCdPriceAlertsIndexRoute: PagesLangPagesCdPriceAlertsIndexRoute,
  PagesLangPagesVinylPriceAlertsIndexRoute:
    PagesLangPagesVinylPriceAlertsIndexRoute,
}

const PagesLangRouteWithChildren = PagesLangRoute._addFileChildren(
  PagesLangRouteChildren,
)

interface PagesRouteChildren {
  PagesLangRoute: typeof PagesLangRouteWithChildren
}

const PagesRouteChildren: PagesRouteChildren = {
  PagesLangRoute: PagesLangRouteWithChildren,
}

const PagesRouteWithChildren = PagesRoute._addFileChildren(PagesRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AboutRoute: AboutRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  HomeRoute: HomeRouteWithChildren,
  LegalRoute: LegalRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  PagesRoute: PagesRouteWithChildren,
  HealthRoute: HealthRoute,
  RobotsDottxtRoute: RobotsDottxtRoute,
  SitemapDotxmlRoute: SitemapDotxmlRoute,
  Sitemap_indexDotxmlRoute: Sitemap_indexDotxmlRoute,
  StoresRoute: StoresRoute,
  ApiMcpRoute: ApiMcpRoute,
  CdnSplatRoute: CdnSplatRoute,
  SitemapArtistsDotxmlRoute: SitemapArtistsDotxmlRoute,
  SitemapCompaniesDotxmlRoute: SitemapCompaniesDotxmlRoute,
  SitemapFeaturesDotxmlRoute: SitemapFeaturesDotxmlRoute,
  SitemapListingsDotxmlRoute: SitemapListingsDotxmlRoute,
  SitemapListsDotxmlRoute: SitemapListsDotxmlRoute,
  SitemapPostsDotxmlRoute: SitemapPostsDotxmlRoute,
  SitemapReleasesDotxmlRoute: SitemapReleasesDotxmlRoute,
  SitemapStaticDotxmlRoute: SitemapStaticDotxmlRoute,
  SitemapUsersDotxmlRoute: SitemapUsersDotxmlRoute,
  SitemapWorksDotxmlRoute: SitemapWorksDotxmlRoute,
  UnsubscribeNotificationsRoute: UnsubscribeNotificationsRoute,
  ApiAuthSplatRoute: ApiAuthSplatRoute,
  ApiDiscogsCallbackRoute: ApiDiscogsCallbackRoute,
  ApiLastfmCallbackRoute: ApiLastfmCallbackRoute,
  ApiPushSubscriptionRoute: ApiPushSubscriptionRoute,
  ApiRpcSplatRoute: ApiRpcSplatRoute,
  ApiUnsubscribeNotificationsRoute: ApiUnsubscribeNotificationsRoute,
  ApiWebhooksRastrRoute: ApiWebhooksRastrRoute,
  ApiWebhooksResendRoute: ApiWebhooksResendRoute,
  ApiWebhooksTelegramRoute: ApiWebhooksTelegramRoute,
  ApiWebhooksWahaRoute: ApiWebhooksWahaRoute,
  SitemapCatalogSplatRoute: SitemapCatalogSplatRoute,
  DotwellKnownApiCatalogIndexRoute: DotwellKnownApiCatalogIndexRoute,
  DotwellKnownOauthAuthorizationServerIndexRoute:
    DotwellKnownOauthAuthorizationServerIndexRoute,
  DotwellKnownOauthProtectedResourceIndexRoute:
    DotwellKnownOauthProtectedResourceIndexRoute,
  DotwellKnownOpenidConfigurationIndexRoute:
    DotwellKnownOpenidConfigurationIndexRoute,
  SitemapCatalogOffersDotxmlIndexRoute: SitemapCatalogOffersDotxmlIndexRoute,
  SitemapCatalogDotxmlIndexRoute: SitemapCatalogDotxmlIndexRoute,
  DotwellKnownOauthAuthorizationServerApiAuthRoute:
    DotwellKnownOauthAuthorizationServerApiAuthRoute,
  DotwellKnownOauthProtectedResourceApiMcpRoute:
    DotwellKnownOauthProtectedResourceApiMcpRoute,
  DotwellKnownMcpServerCardDotjsonIndexRoute:
    DotwellKnownMcpServerCardDotjsonIndexRoute,
  ApiAdsCustomerMatchDotcsvIndexRoute: ApiAdsCustomerMatchDotcsvIndexRoute,
  ApiPartnersOfferWorkbookIndexRoute: ApiPartnersOfferWorkbookIndexRoute,
  ApiInternalMediaAuthorizeUploadIndexRoute:
    ApiInternalMediaAuthorizeUploadIndexRoute,
  ApiInternalMediaCommitUploadIndexRoute:
    ApiInternalMediaCommitUploadIndexRoute,
  ApiInternalMediaSourceReferencesIndexRoute:
    ApiInternalMediaSourceReferencesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { createStart } from '@tanstack/react-start'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
  }
}
